{
    "headerData1": "MyHelp",
    "headerData2": "Il tuo assistente AI per il supporto IT",
    "headerMessage": "Usa <span class='me8eon'>MyHelp</span> per risolvere problemi IT, seguire guide passo-passo o essere indirizzato al canale di supporto IT appropriato.",
    "loginLable": "Accedi",
    "logOff": "Logout",
    "logIn": "Login",
    "userName": "Nome profilo",
    "switchLanguage": "Cambia lingua",
    "switchRole": "Cambia ruolo",
    "new": "NUOVO",
    "whatsnew": "Vedi le novità",
    "whatsnewtt": "Scopri le novità in MyHelp",
    "organiseTiles": "Organizza tessere",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "close": "Chiudi",
    "reset": "Reimposta",
    "continue_Tour": "Continua tour",
    "skip_Tour": "Salta tour",
    "save": "Salva",
    "submit": "Invia",
    "delete": "Elimina",
    "trash_bin": "Elimina",
    "edit": "Modifica",
    "yes": "Sì",
    "no": "No",
    "feedbackWidget": "Feedback",
    "registerLable": "Per registrarsi",
    "underDevelopmentMsg": "Questa pagina è in sviluppo",
    "apiFailDefaultMsg": "Qualcosa è andato storto. Per favore riprova più tardi.",
    "more": "Di più",
    "searchResult": "Risultati di ricerca",
    "showAll": "Mostra tutto",
    "showRelevant": "Mostra rilevanti",
    "assistantTabTooltip": "L'assistenza risponde alle tue domande cercando le risorse interne di E.ON in tempo reale. Fornisce risposte chiare e facili da capire con fonti, così puoi fidarti delle informazioni",
    "searchTabTooltip": "E.ON Search è una ricerca tradizionale che ti aiuta a trovare rapidamente informazioni da diverse fonti E.ON e dai tuoi dati. Fornisce i risultati più rilevanti e i link alle fonti",
    "landingPage": {
        "hello": "Ciao",
        "title": "come posso aiutarti?",
        "searchApps": "App",
        "suggestions": "Suggerimenti"
    },
    "footer": {
        "imprint": "Impronta",
        "privacyPolicy": "Politica sulla privacy",
        "termsofUse": "Termini di utilizzo",
        "contact": "Contatto",
        "PKI": "PKI",
        "privacySettings": "Impostazioni sulla privacy",
        "aboutMe8EON": "Informazioni su MyHelp",
        "copyrights": "Diritti d'autore contenuto"
    },
    "tilePage": {
        "backToSearch": "Torna alla pagina precedente",
        "myInboxCountSuffix": "In sospeso"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Tutti",
            "leaveApptoval": "LeaveApproval",
            "timeSheet": "TimeSheet",
            "claim": "Richiesta",
            "serviceRequest": "ServiceRequest"
        },
        "tableData": {
            "approve": "Approva",
            "reject": "Rifiuta",
            "requestId": "ID richiesta",
            "description": "Descrizione",
            "requestedBy": "Richiesto da",
            "requestedType": "Tipo di richiesta",
            "requestedDate": "Data richiesta",
            "status": "Stato"
        }
    },
    "appData": {
        "time": "Monitoraggio del tempo",
        "meeting": "Prenotazione sala riunioni",
        "approval": "Le mie approvazioni",
        "pr": "Crea richiesta di acquisto",
        "pra": "Crea richiesta di acquisto avanzata",
        "processing": "La mia casella di posta",
        "hr": "Portale HR",
        "hrLabel": "Portale HR",
        "concur": "Prenotazione viaggi e spese Concur",
        "password": "Reset password SAP",
        "ariba": "Ariba - Classico e Classico+",
        "itresources": "Risorse IT",
        "myassets": "I miei beni",
        "order": "Ordine",
        "incident": "Incidenti",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Portale notifiche",
        "zuko": "Zuko",
        "eon_brand": "Spazio del marchio EON",
        "pki": "Portale PKI",
        "mail": "Mail DL",
        "journey": "Viaggi/Eventi",
        "mygenius": "MyGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": "Fascicolo personale - Fascicolo personale digitale - DPF",
        "corpsac": "SAC aziendale",
        "corpportal": "Portale aziendale",
        "redwood": "Automazione finanziaria Redwood",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "Portale SoD SAP",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Bancario: Gestione conti bancari (EBAM)",
        "egs": "Soluzione di garanzia E.ON",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Gestione del rischio",
        "slido": "Slido",
        "insightslibrary": "Biblioteca degli approfondimenti",
        "getabstract": "getAbstract",
        "mypotential": "Raggiungere il mio potenziale",
        "dsesoftware": "Software DSE",
        "whistleblowing": "Soluzione di segnalazione E.ON",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Segnalazione di incidenti",
        "cateringportal": "Piano dei pasti",
        "westnetzregelwerke": "Regolamenti Westnetz",
        "werbemittel": "Materiale pubblicitario",
        "westenergie_brand": "Portale di gestione del marchio",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM e ERM",
        "smartguide": "Guida intelligente",
        "tagetiksac": "Tagetik SAC",
        "myit": "my IT",
        "timehover": "Con l'app CATS, puoi facilmente monitorare e gestire le tue ore di lavoro e attività avendo tutte le informazioni e funzioni pertinenti in un unico posto.",
        "meetinghover": "Con Gingco, il nostro strumento di prenotazione delle sale, puoi gestire e programmare facilmente le tue sale riunioni e risorse, garantendo un utilizzo efficiente e disponibilità, tutto in un unico posto",
        "approvalhover": "Con myInbox, puoi approvare facilmente e in modo efficiente le fatture avendo tutte le informazioni e azioni pertinenti in un unico posto.",
        "prhover": "Qui puoi trovare tutte le funzioni pertinenti per richiedere beni e servizi. Questo è anche noto come BANF (ted. per richiesta di acquisto)",
        "prahover": "Qui puoi trovare tutte le funzioni pertinenti per richiedere beni e servizi. Questo è anche noto come BANF (ted. per richiesta di acquisto)",
        "processinghover": "Con myInbox, puoi approvare facilmente e in modo efficiente le fatture avendo tutte le informazioni e azioni pertinenti in un unico posto.",
        "hrhover": "Con myHR, puoi accedere e gestire comodamente le tue informazioni e attività HR in un unico posto.",
        "concurhover": "Con Concur, puoi gestire e inviare facilmente i tuoi rapporti di viaggio e spese avendo tutte le informazioni e azioni pertinenti in un unico posto.",
        "passwordhover": "Con questa tessera, puoi facilmente reimpostare le password di accesso per i tuoi sistemi SAP.",
        "aribahover": "Con SAP Ariba, puoi gestire facilmente i tuoi processi di approvvigionamento avendo tutte le informazioni e strumenti pertinenti in un unico posto.",
        "itresourceshover": "Risorse IT",
        "myassetshover": "I miei beni",
        "orderhover": "Ordine",
        "incidenthover": "Incidenti",
        "beelinehover": "Con Beeline, puoi gestire efficacemente la tua forza lavoro contingente e semplificare i tuoi processi di assunzione accedendo a tutti gli strumenti e informazioni necessari in un unico posto",
        "prismahover": "PRISMA sta per Piattaforma per la segnalazione di incidenti e gestione della sostenibilità e auditing. La piattaforma supporta il dipartimento HSE di E.ON nella sua missione di rendere E.ON un luogo attento alla salute, sicuro e consapevole dell'ambiente. PRISMA è disponibile sia via web che come app.",
        "gertrudhover": "Gertrud",
        "notificationhover": "Portale notifiche",
        "zukohover": "Zuko",
        "eon_brandhover": "Spazio del marchio EON",
        "pkihover": "Portale PKI",
        "mailhover": "Mail DL",
        "journeyhover": "Viaggi/Eventi",
        "mygeniushover": "MyGenius",
        "ideeonhover": "Idee.on è una piattaforma che consente ai dipendenti di inviare e valutare idee e suggerimenti per la gestione delle idee. È progettata per facilitare un processo di miglioramento continuo in tutte le aree dell'azienda.",
        "ideenethover": "IdeeNet è un software di gestione delle idee nel vero senso della parola. Una varietà di idee, come &#10;&bull; BVW centralizzato, BVW decentralizzato e forme miste &#10;&bull; Cerchi di qualità e CIP &#10;&bull; Rapporti di errore e reclami &#10;&bull; Invenzioni dei dipendenti &#10;possono essere gestite efficacemente con questo software, in un database di idee unificato, ma utilizzando varie strategie.",
        "dpfhover": "Il tuo fascicolo personale contiene molti più documenti di quelli permanentemente visualizzati in MyHR! &#10;Invia una richiesta HR e richiedi l'accesso al tuo intero fascicolo personale! Dopo una revisione professionale, sarà reso disponibile a te tramite link diretto.",
        "corpsachover": "SAC è uno strumento di visualizzazione potente con capacità di pianificazione avanzate",
        "corpportalhover": "Il Portale aziendale è una piattaforma applicativa interna centrale con integrazione e sviluppo di applicazioni basate su ruoli per l'accesso Single-Sign-On ai backend SAP.",
        "redwoodhover": "Redwood FA viene utilizzato per programmare i bilanci consolidati e automatizzare le singole attività",
        "eamsap200hover": "Gestione delle risorse aziendali &#10;Ambiente per sviluppi autonomi basati sulla piattaforma tecnologica Business (BTP) di SAP (precedentemente SAP Cloud Platform) - account EAM per cockpit di rete, inclusi gli istanze cloud: produzione, QA (Assicurazione Qualità), sviluppo e staging.",
        "eamsap100hover": "Gestione delle risorse aziendali &#10;Ambiente per sviluppi autonomi basati sulla piattaforma tecnologica Business (BTP) di SAP (precedentemente SAP Cloud Platform) - account EAM per cockpit di rete, inclusi gli istanze cloud: produzione, QA (Assicurazione Qualità), sviluppo e staging.",
        "sodsaphover": "Il Portale SOD è progettato per semplificare e digitalizzare la gestione della Segregazione dei Compiti (SOD). Digitalizzando l'identificazione, il monitoraggio e la risoluzione dei conflitti SOD, garantisce la conformità agli standard normativi e migliora la sicurezza organizzativa. Questo strumento è essenziale per mantenere un sistema di controllo interno robusto e proteggere le operazioni aziendali.",
        "videonhover": "App per prenotare servizi dallo studio video/TV a Brüsseler Platz per una produzione video/TV o un evento di streaming.",
        "alteryxhover": "Piattaforma di analisi dei dati utilizzata per creare applicazioni analitiche e flussi di lavoro. Consente agli utenti di gestire e condividere applicazioni analitiche, eseguire flussi di lavoro e accedere e riportare sui risultati in un ambiente server",
        "ebamhover": "Gestione elettronica dei conti bancari",
        "egshover": "E.ON SE assume fideiussioni e garanzie per le BU del gruppo verso prestatori esterni",
        "epsnexthover": "Strumento bancario elettronico centrale per tutte le MU/Bus",
        "fisquantumhover": "La Soluzione di Gestione del Tesoro FIS Quantum è progettata per migliorare l'efficienza e l'efficacia delle operazioni di tesoreria della tua organizzazione. Questa piattaforma nativa del cloud fornisce visibilità in tempo reale su liquidità e cassa, consentendo una migliore decisione sulla gestione del capitale e del rischio. Con funzionalità avanzate per la gestione del debito, degli investimenti e della conformità, aiuta a semplificare i flussi di lavoro e migliorare le prestazioni finanziarie.",
        "rmshover": "Sistema di gestione del rischio a livello di gruppo E.ON (elaborazione delle applicazioni di credito e sistema di gestione del rischio di credito)",
        "slidohover": "Slido è una piattaforma interattiva progettata per migliorare il coinvolgimento del pubblico e raccogliere approfondimenti durante eventi dal vivo o virtuali, riunioni e presentazioni. Consente agli utenti di condurre sondaggi dal vivo, sessioni di domande e risposte e quiz in tempo reale, creando un'esperienza dinamica e partecipativa per il pubblico.",
        "insightslibraryhover": "La Biblioteca degli approfondimenti è il repository centrale di conoscenze di E.ON per approfondimenti sui clienti e sul mercato all'interno del business delle soluzioni per i clienti.",
        "getabstracthover": "getAbstract è la biblioteca online a livello di gruppo di E.ON, fornita da getAbstract, con riassunti di libri, articoli e ulteriori formati di apprendimento che coprono tutte le competenze aziendali rilevanti (competenze trasversali e competenze funzionali)",
        "mypotentialhover": "Sistema per i dipendenti e i manager del Regno Unito per registrare le loro prestazioni, obiettivi e recensioni.",
        "dsesoftwarehover": "Formazione e valutazioni su schermo per salute e sicurezza",
        "whistleblowinghover": "Lo strumento di segnalazione consente a chiunque fornisca informazioni di inviare un rapporto in modo anonimo. Questo può essere fatto tramite web intake, email o telefono. Durante una chiamata, la tua voce sarà distorta.",
        "maqsimahover": "Gestione delle valutazioni del rischio, istruzioni operative, sostanze pericolose &#10;Maqsima ti aiuta a tenere traccia rapidamente e facilmente di tutte le valutazioni del rischio e istruzioni operative pertinenti e a mantenerle aggiornate in modo intelligente",
        "digitalrulebookhover": "Paula Policy è l'assistente basato sull'intelligenza artificiale per le policy aziendali di E.ON, che offre ai dipendenti un accesso rapido e semplice alle People Guidelines, alle Function Policies e al Code of Conduct. Fornisce risposte coerenti e affidabili, rendendo le policy complesse facili da comprendere e accessibili.",
        "oneERPhover": "Il portale one.ERP è una piattaforma centrale all'interno del Gruppo Westenergie che consolida varie funzioni e informazioni relative all'ERP. Serve come hub di informazione e controllo per gli utenti ERP e i manager IT ed è parte della strategia di digitalizzazione del gruppo.",
        "Perseushover": "Il Portale di Sicurezza è un punto di accesso centrale per segnalare incidenti legati alla sicurezza all'interno delle organizzazioni Westenergie e Westnetz. È frequentemente utilizzato in combinazione con il sistema di segnalazione interno Perseus, progettato specificamente per gestire incidenti come perdita di dispositivi, furto o violazioni della protezione dei dati.",
        "cateringportalhover": "Il portale eon.cateringportal.io è la piattaforma digitale per l'app E.ON Canteen. Fornisce piani dei pasti, dettagli sulla posizione e altri servizi di catering per i dipendenti E.ON.",
        "westnetzregelwerkehover": "Questo portale serve come risorsa centrale per regolamenti tecnici e documentazione relativa all'operazione e gestione delle reti elettriche e del gas. Garantisce che tutte le linee guida, standard e specifiche tecniche pertinenti richieste per operazioni di rete sicure ed efficienti siano accessibili.",
        "werbemittelhover": "Il negozio di articoli promozionali Westenergie è una piattaforma online attraverso la quale i dipendenti e i partner autorizzati del Gruppo Westenergie possono ordinare articoli promozionali e materiali di comunicazione.",
        "westenergie_brandhover": "Il database delle immagini Westenergie così come gli elementi del marchio e le linee guida di design del Gruppo Westenergie. Accesso a tutti i componenti del nostro marchio per creare momenti Westenergie. Dal sistema di gestione del marchio con tutte le linee guida importanti per l'uso degli elementi del marchio come loghi, simboli e la nostra chat box alla libreria multimediale con numerose immagini per tutte le varianti di design.",
        "compasshover": "Compass è la piattaforma di comunicazione interna a livello di gruppo per notizie e contenuti E.ON, networking e scambio tra dipendenti.",
        "gradarhover": "Questo strumento viene utilizzato per avviare il processo di valutazione dei dipendenti leader.",
        "beqomhover": "Beqom è utilizzato a livello di gruppo per l'amministrazione e la comunicazione dei piani di incentivi a lungo termine di E.ON. È utilizzato da HR, da Contabilità, da Fisco e da Dirigenti. Oltre alle questioni relative ai piani di incentivi a lungo termine, beqom può anche essere utilizzato per la creazione di lettere di pagamento e bonus e dichiarazioni di ricompensa totale.",
        "kychover": "Con lo strumento Know-Your-Counterpart (KYC) puoi esaminare le controparti secondo le politiche standard (es.: PG-03).",
        "talentryhover": "Usa questa opportunità per condividere le nostre attuali offerte di lavoro con persone talentuose nella tua rete - persone che vogliono contribuire a plasmare il futuro con la loro energia.",
        "samhover": "Puoi eseguire corsi di formazione sulla sicurezza obbligatori con questo strumento.",
        "enormhover": "e-NORM è un software potente per gestire, fornire e aggiornare dati relativi all'assicurazione della qualità o documenti standard, nonché collegare file associati.",
        "redonlinehover": "Il Compliance Monitor Red-on-line (ROL) semplifica la gestione della conformità normativa fornendo aggiornamenti in tempo reale sulle normative ambientali, sanitarie e di sicurezza (EHS). Presenta monitoraggio e dashboard per aiutarti a affrontare proattivamente le questioni di conformità. Questo strumento è essenziale per mantenere un ambiente di lavoro sicuro e conforme, ridurre i rischi e migliorare l'efficienza operativa.",
        "tagetikcpmhover": "Applicazione Tagetik Corporate Performance Management (CPM) per budgeting e pianificazione, consolidamento, rischio e reporting di gestione (introdotto da Finance Excellence) di E.ON SE (Group Reporting). I principali processi sono le chiusure trimestrali che hanno un impatto esterno molto elevato a causa della scadenza rigida per la comunicazione al mercato dei capitali.",
        "tagetikcpmermhover": "Applicazione Tagetik Corporate Performance Management (CPM) e Enterprise Risk Management (ERM) per budgeting e pianificazione, consolidamento, rischio e reporting di gestione (introdotto da Finance Excellence) di E.ON SE (Group Reporting). I principali processi sono le chiusure trimestrali che hanno un impatto esterno molto elevato a causa della scadenza rigida per la comunicazione al mercato dei capitali.",
        "smartguidehover": "L'Hub Smart Guide è un wiki che deve essere mantenuto editorialmente da alcuni colleghi per fornire politiche per circa 4000 utenti nelle aree IFRS, Controllo, HGB ed ESG.",
        "tagetiksachover": "Dashboard Tagetik. Tagetik è un'applicazione per budgeting e pianificazione, consolidamento, rischio e reporting di gestione (introdotto da Finance Excellence) di E.ON SE (Group Reporting). I principali processi sono le chiusure trimestrali che hanno un impatto esterno molto elevato a causa della scadenza rigida per la comunicazione al mercato dei capitali.",
        "myithover": "Il tuo punto di riferimento per tutto ciò che riguarda l'IT: opzioni di supporto, link utili, comunità e le ultime notizie che devi conoscere.",
        "servicehub": "Service Hub",
        "servicehubhover": "Con EON Service Hub, puoi facilmente richiedere nuovo software e hardware inclusi laptop e monitor, e ottenere supporto IT sollevando problemi o chattando con il my IT support, tutto in un unico posto.",
        "SailPoint": "Panoramica della gestione delle identità",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Process Design",
        "Celonis": "Celonis Process Mining",
        "Carsync": "Gestione della flotta Carsync",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "Con SailPoint, i diritti di accesso e le identità possono essere gestiti centralmente.",
        "P29hover": "Con SAP EIC, i ticket e le richieste dei clienti possono essere elaborati e documentati in modo efficiente. L'applicazione supporta l'integrazione con ECG e fornisce un'interfaccia centrale per il ticketing.",
        "P83hover": "Con SAP EIC, i ticket e le richieste dei clienti possono essere elaborati e documentati in modo efficiente. L'applicazione supporta l'integrazione con ECG e fornisce un'interfaccia centrale per il ticketing.",
        "BIChover": "Con BIC Cloud, i processi aziendali possono essere modellati, analizzati e ottimizzati.",
        "Celonishover": "Process Mining: Analisi dei processi effettivi basati su registri di eventi da ERP, CRM e altri sistemi. Gestione dell'esecuzione: Automazione dei flussi di lavoro e raccomandazioni di azione. Ottimizzazione dei processi: Identificazione delle inefficienze, ad esempio nei processi Purchase-to-Pay o Order-to-Cash. Integrazione: Connessione a sistemi come SAP, Salesforce, Oracle, ecc.",
        "Carsynchover": "Con Carsync, le auto aziendali e le flotte di veicoli possono essere gestite in modo efficiente, i viaggi documentati e i costi ottimizzati.",
        "ISUSpacehover": "Con ISU/Space, i posti di lavoro e le sale riunioni possono essere facilmente prenotati e gestiti.",
        "GNIShover": "Con GNIS, i dati master e di rete per la comunicazione di mercato (EDI) possono essere gestiti e scambiati in modo efficiente.",
        "ecount_EDIhover": "Con eccount, i dati master e di rete rilevanti per EDI possono essere gestiti, scambiati e analizzati.",
        "SAP_Datasphere_EDIhover": "Con SAP Datasphere, i dati provenienti da varie fonti possono essere integrati, modellati e resi disponibili per analisi e decisioni aziendali. La piattaforma supporta il self-service, la governance dei dati e l'accesso ai dati in tempo reale.",
        "CFLP": "CFLP",
        "corporateWorkspace": "Corporate Workspace",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "CFLPhover": "Punto di accesso centrale per i sistemi SAP e i servizi cloud.",
        "corporateWorkspacehover": "SAP Build Work Zone, Advanced Edition consente di creare soluzioni di workspace digitale per aumentare la produttività e il coinvolgimento degli utenti. Centralizza l'accesso ad applicazioni aziendali, processi, informazioni e comunicazioni in un unico punto di accesso, disponibile da qualsiasi dispositivo.",
        "SAPWebLaunchpadhover": "SAP Web Launchpad fornisce accesso ai sistemi SAP tramite il web utilizzando Fiori e WebGUI. La pagina iniziale personalizzabile, inclusi i preferiti, consente un accesso rapido ai sistemi SAP e ai client.",
        "PKI_Semnatura_Digitala_6781": "PKI - Firma digitale",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Valutazione del personale EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Segnalazioni gestione edifici EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Trasferte EER",
        "Users_Access_EER_5369": "Accesso utenti EER",
        "Planificare_Concedii_EER_8588": "Pianificazione ferie EER",
        "Pontaje_si_Telemunca_EER_7087": "Presenze e telelavoro EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Premio al personale",
        "GRC_Request_5510": "Richiesta GRC",
        "iPEN_Portal_3047": "Portale iPEN",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "Portale IT (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "Segnala un incidente di sicurezza IT VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "Segnala un incidente HSE VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Menu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "Modulo di segnalazione IT VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Certificati e altre applicazioni HR (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Rimborsi con carta aziendale (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Documenti di trasferta (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "Reimposta token",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Portale valutazione del personale EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Portale segnalazioni gestione edifici EER",
        "MRBS_EER_8445hover": "Prenotazione sala riunioni EER",
        "Delegatii_EER_1137hover": "Portale trasferte EER",
        "Users_Access_EER_5369hover": "Modulo accesso utenti EER",
        "Planificare_Concedii_EER_8588hover": "Pianificazione ferie EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Presenze e telelavoro EER",
        "BOT_6231hover": "Rimborso buoni vacanza e cure",
        "Bonusare_personal_6879hover": "Premio al personale",
        "GRC_Request_5510hover": "GRC sta per Governance & Risk Compliance Access Control ed è uno strumento di workflow SAP per la richiesta, l'approvazione e l'assegnazione automatizzate delle autorizzazioni utente nei sistemi SAP.",
        "iPEN_Portal_3047hover": "Information Platform of Energy Networks, in breve iPEN, garantisce che i dati delle unità regionali possano essere aggregati e resi disponibili centralmente. Le soluzioni intelligenti esistenti e quelle di nuova progettazione vengono collegate alla piattaforma. In questo modo possono essere distribuite in modo economico, rapido e flessibile in tutta la comunità di rete. iPEN è quindi l'abilitatore centrale per la scalabilità delle soluzioni intelligenti.",
        "YourVoiceEON_0693hover": "La piattaforma PEAKON ti invia circa 4-5 domande una volta a settimana su aspetti legati al tuo benessere e alla tua situazione lavorativa attuale. Puoi valutare le domande (da 0 a 10), commentarle oppure saltarle. Rispondere a queste poche domande richiede solo circa 1-2 minuti.",
        "ITPortal_5530hover": "Portale di servizi IT di Süwag",
        "Transf4m_Ticket_Tool_6635hover": "Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Menu",
        "Ariba_8690hover": "Portale acquisti",
        "DiSch_20_0545hover": "Questo e il mio posto di lavoro digitale",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Confluence di Süwag",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Rendicontazione del tempo",
        "CTP_2407hover": "CTP (Il tempo è denaro)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Supporto all'elaborazione dei processi aziendali con Jira",
        "Qmatic_PL_CS_3195hover": "Applicazione per gestire il flusso di clienti (code) nei punti vendita (POS)",
        "Qmatic_PL_EN_3118hover": "Applicazione per gestire il flusso di clienti (code) nei punti vendita (POS)",
        "CCM_Inspire_7264hover": "La piattaforma centralizzata di E.ON per la gestione della comunicazione con i clienti (CCM), basata su Quadient Inspire, per creare e distribuire le comunicazioni ai clienti.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "Questo è il nostro sistema di rilevazione delle presenze",
        "Atoss_VSEGruppe_4374hover": "Questo è il nostro sistema di rilevazione delle presenze",
        "AWS_Access_Portal_1318hover": "Accesso agli account AWS",
        "eDIVA_5372hover": "Gestione utenti ANF",
        "G2G_VSEGruppe_6518hover": "Sistema GIS di VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Accesso al Cloud AWS VSE-Gruppe",
        "Qualys_Security_4331hover": "Monitoraggio del rischio aziendale",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "Segnala un incidente di sicurezza IT VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "Segnala un incidente HSE VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Menu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "Modulo di segnalazione IT VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Istruzioni",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Lo scopo di questa applicazione è consentire a ogni utente di scaricare diversi tipi di certificati con un massimo di tre clic. L'applicazione offre anche funzioni per gli amministratori HR e i coordinatori, che possono scaricare certificati per i colleghi di cui sono responsabili. Inoltre, i dipendenti possono calcolare l'anzianità di servizio e il supporto pensionistico, e richiedere altri documenti al dipartimento HR.",
        "Deconturi_card_companie_RO_CS_5333hover": "I titolari di carte aziendali possono inviare facilmente le note spese tramite questa applicazione, senza dover inviare ricevute per e-mail o posta né richiedere approvazioni via e-mail. L'intero processo avviene su questa piattaforma.",
        "Documente_delegatii_RO_CS_5332hover": "L'applicazione per la gestione delle trasferte consente agli utenti di aggiungere documenti alle proprie trasferte e a quelle dei propri collaboratori. Gli amministratori HR possono visualizzare, filtrare e chiudere documenti in blocco, nonché richiederne altri tramite e-mail inviate automaticamente.",
        "SAP_ISU_CS_RO_8555hover": "Il servizio copre le attività relative ai sistemi SAP IS-U x7G utilizzati da E.ON RO CS.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Rinnovare / Reimpostare il token",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Portale valutazione del personale EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Portale segnalazioni gestione edifici EER",
            "MRBS_EER_8445subTitle": "Prenotazione sala riunioni EER",
            "Delegatii_EER_1137subTitle": "Portale trasferte EER",
            "Users_Access_EER_5369subTitle": "Modulo accesso utenti EER",
            "Planificare_Concedii_EER_8588subTitle": "Pianificazione ferie EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Presenze e telelavoro EER",
            "BOT_6231subTitle": "Rimborso buoni vacanza e cure",
            "Bonusare_personal_6879subTitle": "Premio al personale",
            "GRC_Request_5510SubTitle": "Richiesta GRC",
            "iPEN_Portal_3047SubTitle": "Piattaforma informativa delle reti energetiche",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Prenotazione postazioni di lavoro",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Portale acquisti",
            "DiSch_20_0545SubTitle": "Posto di lavoro digitale",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Monitoraggio delle attività aziendali",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Elaborazione dei processi aziendali",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Piattaforma",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA Gestione utenti ANF -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "Segnala un incidente di sicurezza IT VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "Segnala un incidente HSE VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Menu VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "Modulo di segnalazione IT VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Certificati e altre applicazioni HR (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Rimborsi con carta aziendale (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Documenti di trasferta (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Fiori Launchpad Centrale",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Link ai sistemi SAP",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "Sistemi SAP",
            "aribaSubTitle": "Panoramica PO",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "Ordina servizi IT",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "Assunzioni esterne",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Prepara riunioni del consiglio",
            "notificationSubTitle": "Servizi di struttura",
            "zukoSubTitle": "Organizza trasloco ufficio",
            "eon_brandSubTitle": "è su di noi",
            "pkiSubTitle": "Gestisci certificati",
            "mailSubTitle": "Mantieni",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Piattaforma di apprendimento digitale",
            "ideeonSubTitle": "Gestione delle idee",
            "ideenetSubTitle": "Gestione delle idee",
            "dpfSubTitle": "Fascicolo personale digitale",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Portale aziendale",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "Cockpit cloud SAP (200)",
            "eamsap100SubTitle": "Cockpit cloud SAP (100)",
            "sodsapSubTitle": "Portale SoD",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Repository di conoscenze",
            "getabstractSubTitle": "Biblioteca online",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "Soluzione di segnalazione E.ON",
            "maqsimaSubTitle": "Gestione delle valutazioni del rischio",
            "digitalrulebookSubTitle": "Linee guida del gruppo",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Cateringportal",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Negozio di articoli promozionali",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Piattaforma di comunicazione interna a livello di gruppo",
            "gradarSubTitle": "Valutazione del lavoro e compensazione",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Controllo di conformità delle controparti",
            "talentrySubTitle": "Programma di referenze lavorative",
            "samSubTitle": "Formazione sulla sicurezza @E.On",
            "enormSubTitle": "Monitor di conformità",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM e ERM",
            "smartguideSubTitle": "Smart Guide Hub (Wiki contabile)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "servicehubSubTitle": "Service Hub",
            "myitSubTitle": "Supporto IT e notizie",
            "SailPointSubTitle": "Panoramica sulla gestione delle identità e degli accessi",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Process Mining",
            "CarsyncSubTitle": "Gestione della flotta",
            "ISUSpaceSubTitle": "Gestione degli spazi di lavoro e delle sale",
            "GNISSubTitle": "Gestione dei dati master EDI",
            "ecount_EDISubTitle": "Gestione dei dati EDI",
            "SAP_Datasphere_EDISubTitle": "Integrazione dei dati e Business Data Fabric",
            "ukhrSubTitle": "UK HR App"
        },
        "ukhr": "UK HR App",
        "ukhrhover": "Il tuo punto di riferimento per tutto ciò che riguarda le risorse umane nel Regno Unito. Dai cedolini alle prenotazioni delle vacanze e tutto il resto. Inizia con le nostre guide per dipendenti e manager o cerca tutto ciò che riguarda le risorse umane qui sotto."
    },
    "searchPage": {
        "searchPlaceholder": "Cerca...",
        "searchApps": "Cerca qui...",
        "relatedApps": "App",
        "viewMoreApps": "Altro",
        "removeAppTooltip": "Rimuovi dal Dashboard",
        "addAppTooltip": "Aggiungi al Dashboard",
        "addedAppTooltip": "Aggiunto al Dashboard"
    },
    "pwaText": {
        "header": "Installa questa app sulla tua schermata principale!",
        "button": "Installa App",
        "iphoneHeader": "Per installare questa app su iPhone",
        "inst1": "Tocca il pulsante <b>Condividi</b> in Safari.",
        "inst2": "Scorri verso il basso e seleziona <b>\"Aggiungi alla schermata principale\".</b>",
        "inst3": "Tocca <b>Aggiungi</b> nell'angolo in alto a destra."
    },
    "filterPage": {
        "filterMenu": {
            "backBtn": "Torna alla pagina precedente",
            "disclaimer": "Alcuni risultati potrebbero non essere completamente rilevanti. Si prega di esaminare attentamente.",
            "loading": "Caricamento",
            "app": "App",
            "gitlab": "Gitlab",
            "apps": "App",
            "all": "Tutti",
            "m365": "I miei file",
            "jql": "jql",
            "people": "Persone",
            "emails": "Le mie email",
            "teams": "Team",
            "community": "Comunità",
            "pages": "Pagine",
            "users": "Utenti",
            "noData": "Non siamo riusciti a trovare alcun risultato per",
            "noMoreData": "Nessun ulteriore risultato trovato per la tua query!",
            "filterHeading": "Filtri",
            "reset": "Ripristina filtri",
            "refineResults": "Affina risultati",
            "card_languages": "Lingue",
            "ecl_source_name": "Fonte",
            "standard_card_type": "Tipo",
            "mimeType": "Tipo",
            "datasources": "Fonti di dati",
            "lookingFor": "Sto cercando",
            "timeRange": "Intervallo di tempo",
            "department": "Dipartimento",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "Il mio ordine IT",
            "aiAssistant": "Assistenza",
            "space": "Spazio",
            "time": "Tempo",
            "priority": "Priorità",
            "status": "Stato",
            "compass": "Bussola",
            "contentType": "Categoria",
            "kb_articles": "Supporto IT",
            "officeBuddy": "E.ON Knowledge base",
            "key": "Progetto",
            "enterSearchTerm": "Inserisci il tuo termine di ricerca e affina i risultati.",
            "categoryTags": "Categoria",
            "companyTags": "Area aziendale",
            "searchIn": "Cerca in"
        },
        "searchResult": {
            "source": "Fonte",
            "business": "Business",
            "mobile": "Mobile",
            "type": "Tipo",
            "duration": "Durata",
            "category": "Categoria",
            "deliveryTime": "Tempo di consegna",
            "availableLanguages": "Lingue disponibili",
            "status": "Stato",
            "lastUpdate": "Ultimo aggiornamento",
            "lastUpdated": "Ultimo aggiornamento",
            "createdOn": "Creato il",
            "createdBy": "Creato da",
            "company": "Azienda",
            "department": "Dipartimento",
            "job_title": "Titolo del lavoro",
            "office_location": "Posizione dell'ufficio",
            "email": "Email",
            "preview": "Anteprima",
            "viewEmail": "Visualizza Email"
        },
        "timeRangeOptions": {
            "All": "Tutti",
            "yesterday": "1 Giorno",
            "lastWeek": "7 Giorni",
            "lastMonth": "1 Mese",
            "6 Months": "6 Mesi",
            "lastYear": "1 Anno"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "il mio ordine IT",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Knowledge Base",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Altro"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Tutte le aree aziendali"
        },
        "searchOptionsHover": "Mostra contenuti dalla tua area aziendale, contenuti del gruppo E.ON o contenuti da altre aree aziendali."
    },
    "chatBot": {
        "chatIcon": "ChatBot",
        "sourceName": "Fonte",
        "searchBack": "Torna alla pagina precedente",
        "welcomeMessage": "Chat Prompt",
        "chatbotPlaceholder": "Scrivi qui...",
        "sendbtn": "Invia",
        "cancelBtn": "Annulla",
        "showMore": "Mostra di più",
        "showMoreTooltip": "Mostra risposta completa",
        "showLess": "Mostra meno",
        "showLessTooltip": "Minimizza risposta completa",
        "continueAssistance": "Continua su Assistenza",
        "continueAssistanceTooltip": "Continua su Assistenza per fare domande di follow-up",
        "feedbackTitle": "È stato utile?",
        "feedbackThumbsUpLabel": "Sì, è stato utile",
        "feedbackThumbsDownLabel": "Hai ancora bisogno di aiuto?",
        "feedbackPrompt": "Condividi il tuo Feedback qui",
        "askMe": "Fai la tua domanda",
        "imageUpload": "Carica immagine",
        "uploadImageTooltip": "Carica immagine e fai una domanda.",
        "uploadImageFormat": "Formato supportato: JPG/PNG",
        "uploadImageProcessing": "Elaborazione immagine...",
        "uploadImageQuestions": "Domande suggerite:",
        "card": {
            "selfService": "Self Service",
            "efficiency": "Efficienza",
            "ngService": "Servizio di nuova generazione"
        },
        "disclaimerText": "L'assistenza potrebbe generare contenuti inaccurati e difettosi. Controlla le informazioni importanti.",
        "selfServiceTitle": "Supporto IT",
        "selfServiceContent": "Supporto self service abilitato dall'AI per una rapida risoluzione degli incidenti di servizio",
        "knowledgeBaseTitle": "Base di Conoscenza",
        "knowledgeBaseContent": "Migliorare l'esperienza dei dipendenti attraverso l'informazione",
        "internetSearchTitle": "Domande Generali",
        "wentWell": "Cosa è andato bene? (opzionale)",
        "wentWrong": "Cosa non è andato bene?",
        "privacyMsg": "Rispettiamo la privacy e assicuriamo che i feedback saranno gestiti in modo confidenziale.",
        "appreciateService": "Apprezziamo il tuo aiuto nel migliorare i nostri servizi.",
        "feedbackMessage": "Grazie per il tuo Feedback!",
        "relevantSearches": "Ricerche più rilevanti",
        "aiAssitanceSuggestion": "Puoi fare le tue domande all'assistenza AI utilizzando la casella di input qui sotto",
        "aiActionMsg": "Sembra che il tuo spazio di archiviazione interno sia pieno. Posso aiutarti a risolvere il problema di installazione pulendo automaticamente i tuoi file temporanei e svuotando il cestino. Vuoi che pulisca automaticamente?",
        "aiActionPrimaryBtn": "Pulisci automaticamente",
        "aiActionSecondaryBtn": "Non pulire automaticamente",
        "aiActionSuccess": "Il tuo spazio di archiviazione è stato pulito.",
        "aiActionFailed": "Qualcosa è andato storto. Per favore, prova più tardi. Oppure prova manualmente.",
        "hey": "Ciao",
        "topicStartMessage": "con quale problema IT posso aiutarla oggi?",
        "newChat": "Nuova Chat",
        "open": "Apri",
        "close": "Chiudi",
        "recentChats": "Chat Recenti",
        "ask": "Chiedi",
        "internet": "Internet",
        "askEon": "Chiedi a E.ON",
        "askInternet": "Chiedi a Internet",
        "askFollowUpQuestion": "Fai una domanda di follow-up",
        "resolveIssue": "La presentazione del Feedback abiliterà azioni di supporto",
        "resolveIssueAfterFeedback": "Mi dispiace di non essere riuscito a risolvere il tuo problema. Come posso aiutarti ulteriormente?",
        "differentiator": "o",
        "incident": "Apri ticket di servizio",
        "creatingIncident": "Creazione di un incidente",
        "liveAgent": "Chatta con un agente",
        "requestCallbackBtn": "Richiedi richiamata",
        "ticketDescription": "Descrizione del ticket basata sulla discussione recente",
        "createIncident": "Crea incidente",
        "confirmCreateIncident": "Conferma e crea incidente",
        "editCreateIncident": "Modifica e crea incidente",
        "ticketSuccessMsg": "Il tuo incidente è stato creato con successo, Numero del Ticket: ",
        "ticketErrorMsg": "Qualcosa è andato storto. Per favore, prova più tardi.",
        "chatBotTitle": "Usa l'assistenza MyHelp per fare una domanda, ottenere supporto e informazioni utili da fonti interne ed esterne.",
        "duplicateError": "Domanda duplicata, per favore fai una domanda diversa",
        "content": "Contenuto",
        "tone": "Tono",
        "information": "Informazione",
        "complete": "Completo",
        "other": "Altro",
        "irelevantContent": "Contenuto irrilevante",
        "lackOfDetail": "Mancanza di dettagli",
        "incorrectInformation": "Informazioni errate",
        "copyLink": "Copia link",
        "openLink": "Apri link",
        "internetSearchContent": "Basato su chiedi qualsiasi cosa EON gpt",
        "assignmentGroupForTicket": "eon-uk-gsd",
        "copy": "Copia",
        "share": "Condividi",
        "copiedMsg": "Copiato con successo",
        "copyLinkMsg": "Copia link",
        "sharableLink": "Link condivisibile",
        "uploadImage": "Carica immagine e fai una domanda",
        "liveAgentChat": {
            "connectWithLiveAgent": "Connettiti con il my IT support",
            "connectingWithLiveAgent": "Connessione con il my IT support",
            "connectingHint": "Puoi tornare all'assistenza cliccando il link sotto la casella di chat",
            "agentLeftMsg": "Grazie per aver contattato E.ON",
            "switchToAssistance": "Esci dalla chat e passa all'assistenza",
            "typeMessageHint": "Scrivi il tuo messaggio qui...",
            "disconnectingMsg": "Uscita dalla chat e passaggio all'assistenza",
            "continue": "Continua",
            "exitChat": "Esci dalla chat",
            "chatSessionEndPrompt": "La sessione di chat terminerà automaticamente in <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "MyHelp Assistance ha rilevato che la tua lingua predefinita è “<language>”. Conferma per essere connesso con un agente o modifica la lingua e il tipo di agente desiderati qui sotto.",
            "channelsText": "Ricevi richiamata tramite",
            "languageText": "Lingua di comunicazione",
            "channelLabel": "Seleziona canale",
            "phoneLabel": "Connettimi tramite",
            "languageLabel": "Seleziona lingua",
            "tryAgain": "Riprova",
            "technicalIssue": "Impossibile completare la tua richiamata a causa di un problema tecnico. Per favore, prova di nuovo.",
            "newNumber": "Nuovo numero",
            "availableMobileNumbers": "Numeri di cellulare disponibili",
            "chosenNumber": "Connettimi su questo numero",
            "phoneError": "Per favore, inserisci un numero di contatto valido",
            "referenceNumber": "Numero di riferimento",
            "tooltip": {
                "confirmBtn": "Conferma per effettuare una richiesta di richiamata",
                "resetBtn": "Reimposta il modulo per cancellare tutte le selezioni e ricominciare",
                "cancelBtn": "Annulla richiamata"
            },
            "addNewNumber": "nuovo numero"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Crea ticket",
                "chatWithServiceDesk": "Avvia chat dal vivo",
                "requestCallback": "Richiedi richiamata",
                "ongoingConversation": "Sì, fa parte della mia ultima conversazione.",
                "newConversation": "No. Ho bisogno di aiuto per risolvere un nuovo problema",
                "confirmAndCreateTicket": "Conferma e crea ticket",
                "cancelTicketCreation": "Annulla creazione ticket",
                "confirmChatWithServiceDesk": "Conferma e connettiti con il my IT support",
                "cancelChatWithServiceDesk": "Annulla chat con my IT support",
                "cancelRequestCallback": "Annulla richiesta di richiamata",
                "confirmRequestCallback": "Conferma di connetterti tramite <channel> <phone> con un agente del my IT support in lingua <language>"
            },
            "state": {
                "whatsTheIssue": "Qual è il problema che stai cercando di risolvere?",
                "lastConversation": "Certo, il problema fa parte dell'ultima conversazione?",
                "createIncidentLabel": "Stai per aprire un ticket di incidente per",
                "cancelAck": "Annotato. Posso aiutarti con qualche altro problema?",
                "chatWithServiceDeskLabel": "Stai per connetterti con un agente del my IT support",
                "createTicketLabel": "Conferma e crea ticket",
                "cancelTicketLabel": "Annulla creazione ticket",
                "creatingIncidentTicket": "Creazione ticket di incidente",
                "ticketAttachment": "Per favore, aggiungi uno screenshot dell'errore o del problema.",
                "ticketAttachmentTooltipInstruction": "Premi il tasto logo Windows + Stampa schermo o usa lo strumento di cattura per acquisire un'immagine.",
                "ticketAttachmentTooltipWarning": "Dimensione immagine inferiore a 5MB",
                "ticketAttachmentLabel": "Allega uno screenshot",
                "ticketAttachmentTitle": "Screenshot allegato per il ticket",
                "ticketAttachmentError": "Impossibile allegare il file selezionato. Assicurati che il file selezionato sia in formato jpg, png e inferiore a 5MB.",
                "ticketAttachmentErrorAction": "Riprova",
                "ticketDescription": "Descrizione del ticket",
                "ticketNonITWarning": "L'assistenza non ha trovato parole chiave per identificare il tuo problema come un problema IT.",
                "ticketNonITWarningQuestion": "Vuoi creare un incidente con il my IT support basato sulla tua conversazione su",
                "ticketNonITWarningRecommendationLabel": "Raccomandazione:",
                "ticketNonITWarningRecommendationText": "se hai un problema che non è correlato a software o hardware puoi provare a riformulare la tua ricerca o fare una domanda di follow-up qui sotto",
                "connectWithServiceDeskLabel": "Conferma per chattare con il my IT support",
                "requestCallbackLabel": "Richiedi richiamata",
                "requestCallbackInQueuePhone": "La tua richiesta di richiamata è stata inviata. Sarai contattato entro circa 5 minuti al numero <strong><phone></strong>. Nel frattempo puoi continuare a utilizzare altre applicazioni.",
                "requestCallbackInQueueTeams": "La tua richiesta di richiamata è stata inviata. Sarai contattato entro circa 5 minuti tramite <strong>Microsoft Teams</strong>. Nel frattempo puoi continuare a utilizzare altre applicazioni.",
                "requestCallbackFailed": "Non siamo riusciti a completare la tua richiamata a causa di un problema tecnico. Per favore, prova di nuovo.",
                "requestCallbackPromptAnswer": "Stai per richiedere una richiamata dal my IT support",
                "requestCallbackConfirmLabel": "Conferma per richiedere una richiamata"
            },
            "tooltips": {
                "createIncident": "Ti assiste risolvendo un problema IT e creando un incidente con il my IT support, se necessario",
                "chatWithServiceDesk": "Ti assiste risolvendo un problema IT e contattando il my IT support tramite chat, se necessario",
                "requestCallback": "Richiedi richiamata dal my IT support"
            }
        },
        "askTooltip": {
            "eon": "Ottieni informazioni specifiche dell'azienda da fonti interne",
            "internet": "Ottieni informazioni da fonti interne ed esterne come E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "Visualizza in Jira",
            "responseHeading": "Ecco il riepilogo dei tuoi ticket Jira:",
            "responseSubheading": "Mostrando i primi 15 record",
            "noResponse": "Sembra che non ci siano ticket JIRA disponibili per la tua richiesta in questo momento.",
            "supportedQuestionMsg": "Ciao, mi dispiace. Non ho capito bene la tua domanda. Puoi riformularla? Sto condividendo alcune domande di esempio per aiutarti:"
        },
        "intune": {
            "selectDevice": "Seleziona un dispositivo",
            "changeBrowserHomePage": "Cambia pagina iniziale del browser",
            "fixWillBeApplied": "La correzione verrà applicata a questo sistema",
            "confirm": "Conferma",
            "fixThis": "Correggi",
            "enterDeviceName": "Inserisci il nome del dispositivo",
            "selectOrEnterDevice": "Seleziona un dispositivo o inserisci il nome del tuo dispositivo.",
            "actionFailed": "Azione fallita.",
            "working": "In corso...",
            "fixOnThis": "Applica su questo dispositivo",
            "deviceLabel": "Dispositivo",
            "lastActive": "Ultima attività",
            "today": "Oggi",
            "yesterday": "Ieri",
            "daysAgo": "giorni fa",
            "deviceTypeLaptop": "Laptop",
            "deviceTypeDesktop": "Desktop",
            "deviceTypeVirtualMachine": "Macchina virtuale",
            "deviceTypeUnknown": "Dispositivo",
            "homepageBrowserChange": {
                "syncInstructions": "La modifica verrà ora applicata al tuo dispositivo. Questa operazione può richiedere circa 90 minuti. Se desideri velocizzare il processo, puoi avviare una sincronizzazione manuale da Company Portal:\n1. Apri Company Portal\n2. In basso a sinistra, fai clic su Settings accanto al simbolo dell'ingranaggio.\n3. Poi fai clic sul pulsante blu \"Synchronize\" e attendi il completamento della sincronizzazione.",
                "changeHomepageInstructions": "1. Fai clic sui tre puntini (...) nell'angolo in alto a destra.\n2. Seleziona “Impostazioni”.\n3. Nel menu a sinistra, seleziona “Start, home e nuova scheda”.\n4. In “All'avvio”, assicurati che “Apri siti personalizzati” sia selezionato/spuntato.\n5. Poi fai clic su “Aggiungi sito”.\n6. Inserisci l'indirizzo del sito web che desideri impostare come nuova Pagina iniziale in Microsoft Edge (ad esempio: https://compass.eon.com/).\n7. Fai clic su “Aggiungi”.\n\nSe vuoi rimuovere un sito dall'elenco Pagina iniziale, fai clic sui tre puntini (...) accanto al sito e poi su “Rimuovi”.",
                "policyDescription": "La tua organizzazione attualmente gestisce le impostazioni della pagina iniziale del browser tramite criteri del dispositivo. Per abilitare la modifica della pagina iniziale, dobbiamo prima identificare quale dispositivo dovrebbe ricevere l'aggiornamento del criterio.",
                "deviceSelectedForPolicy": "selezionato per lo sblocco dei criteri della homepage",
                "stepsForEdge": "Passaggi per modificare la homepage nel browser Microsoft Edge",
                "whatsNextTitle": "Cosa succede dopo?",
                "whatsNextSubmitted": "Una richiesta per consentire una homepage personalizzabile è stata inviata alla coda dei criteri del tuo dispositivo. ",
                "whatsNextSyncTime": "<strong>90 minuti</strong> tempo medio di sincronizzazione necessario per l'aggiornamento dei criteri in background. ",
                "whatsNextReturn": "Ti preghiamo di tornare alle impostazioni del browser dopo 90 minuti ed eseguire i passaggi seguenti. ",
                "homepageEnabled": "Ora puoi modificare le impostazioni della homepage del tuo browser. Si prega di notare che la modifica potrebbe non avere effetto immediatamente. Attendere circa 30 minuti affinché la sincronizzazione abbia luogo, quindi chiudere e riaprire Edge.",
                "homepageAlreadyEnabled": "Il tuo dispositivo ha già abilitato la modifica della homepage. Vai alle impostazioni del browser e riprova.",
                "homepageEnableFailed": "Non posso abilitare la modifica della homepage in questo momento. Per favore riprova più tardi.",
                "homepageRemoved": "Dispositivo rimosso dal gruppo di criteri della homepage."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Oops! Qualcosa è andato storto. Per favore, prova più tardi. Se il problema persiste, apri un problema dalle Azioni rapide",
            "assistanceTask": "Compito di Assistenza",
            "myActions": "Le mie Azioni",
            "itReportTitle": "Ecco il tuo snapshot di efficienza energetica dei sistemi",
            "days": "Giorni",
            "device": "Dispositivo",
            "sinceRestarted": "da quando è stato riavviato",
            "deviceRestartRecommendation": "È consigliato un riavvio immediato del dispositivo",
            "deviceInCompliance": "Il tuo dispositivo è conforme",
            "energyConsumed": "Energia consumata negli ultimi 7 giorni",
            "coEmitted": "CO2 emessa negli ultimi 7 giorni",
            "cacheActionMsg": "Per favore, riavvia il tuo browser affinché le modifiche abbiano effetto.",
            "diskClean": {
                "primaryBtn": "Sì, pulisci il mio disco ora",
                "secondaryBtn": "Non pulire ora",
                "successMsg": "Il tuo disco è stato pulito",
                "successMsgOnList": "Il tuo disco è stato pulito",
                "failureMsg": "Il tuo disco non può essere pulito in questo momento",
                "progressMsg": "Pulizia dello spazio di archiviazione in corso",
                "disclaimer": "Si prega di notare che non toccheremo i tuoi dati personali o di lavoro. Mentre la pulizia avviene in background, sentiti libero di usare l'assistenza.",
                "acknowledgeQuery": "Posso eseguire la pulizia del disco per te. Durante la pulizia del disco vengono rimossi file non necessari, cache o vecchi log nel tuo sistema. Fai clic sul pulsante qui sotto per procedere."
            },
            "chromeCache": {
                "primaryBtn": "Sì, pulisci la cache di Chrome ora",
                "secondaryBtn": "Non pulire la cache di Chrome ora",
                "successMsg": "La tua cache di Chrome è stata pulita. Per favore, riavvia il tuo browser affinché le modifiche abbiano effetto.",
                "successMsgOnList": "La tua cache di Chrome è stata pulita",
                "failureMsg": "La tua cache di Chrome non può essere pulita in questo momento",
                "progressMsg": "Pulizia della cache di Chrome in corso",
                "disclaimer": "Si prega di notare che non toccheremo i tuoi dati personali o di lavoro. Mentre la pulizia avviene in background, sentiti libero di usare l'assistenza.",
                "acknowledgeQuery": "Posso aiutarti a svuotare la cache del browser. Fai clic sul pulsante qui sotto per procedere."
            },
            "edgeCache": {
                "primaryBtn": "Sì, pulisci la cache di Edge ora",
                "secondaryBtn": "Non pulire la cache di Edge ora",
                "successMsg": "La tua cache di Edge è stata pulita. Per favore, riavvia il tuo browser affinché le modifiche abbiano effetto.",
                "successMsgOnList": "La tua cache di Edge è stata pulita",
                "failureMsg": "La tua cache di Edge non può essere pulita in questo momento",
                "progressMsg": "Pulizia della cache di Edge in corso",
                "disclaimer": "Si prega di notare che non toccheremo i tuoi dati personali o di lavoro. Mentre la pulizia avviene in background, sentiti libero di usare l'assistenza.",
                "acknowledgeQuery": "Posso aiutarti a svuotare la cache del browser. Fai clic sul pulsante qui sotto per procedere."
            },
            "empowerApp": {
                "primaryBtn": "Sì, per favore ripara ora",
                "secondaryBtn": "Non riparare ora",
                "successMsg": "Riparazione automatica completata con successo",
                "successMsgOnList": "Riparazione automatica completata con successo",
                "failureMsg": "Il tuo plugin Empower non può essere riparato in questo momento",
                "progressMsg": "Riparazione automatica in corso",
                "disclaimer": "Reinstalleremo il plugin Empower, si prega di chiudere tutte le app O365 prima di procedere ulteriormente.",
                "acknowledgeQuery": "Posso aiutarti con i problemi relativi al componente aggiuntivo Empower. Fai clic qui sotto per riparare il plug-in Empower."
            },
            "teamsCache": {
                "primaryBtn": "Sì, pulisci la cache di Teams ora",
                "secondaryBtn": "Non pulire la cache di Teams ora",
                "successMsg": "La tua cache di Teams è stata pulita. Puoi aprire Teams e riconfigurare qualsiasi impostazione che potrebbe essere stata ripristinata.",
                "successMsgOnList": "La tua cache di Teams è stata pulita",
                "failureMsg": "La tua cache di Teams non può essere pulita in questo momento",
                "progressMsg": "Pulizia della cache di Teams in corso",
                "disclaimer": "Si prega di notare che non toccheremo i tuoi dati personali o di lavoro. Mentre la pulizia avviene in background, sentiti libero di usare l'assistenza.",
                "acknowledgeQuery": "Posso aiutarti a svuotare la cache di Teams. Fai clic sul pulsante qui sotto per procedere."
            },
            "teamsReinstall": {
                "primaryBtn": "Sì, reinstalla Teams",
                "secondaryBtn": "Non reinstallare Teams",
                "successMsg": "Reinstallazione dell'app Teams completata",
                "successMsgOnList": "Reinstallazione dell'app Teams completata",
                "failureMsg": "La reinstallazione di Teams non può essere completata",
                "progressMsg": "Reinstallazione di Teams in corso",
                "disclaimer": "Si prega di notare che questo scaricherà e reinstallerà contemporaneamente l'app Teams. Questo riavvierà l'app Teams, si prega di salvare il lavoro prima di procedere ulteriormente.",
                "acknowledgeQuery": "La reinstallazione dell'app Microsoft Teams potrebbe risolvere il problema. Fai clic sul pulsante qui sotto per procedere."
            },
            "outlookOst": {
                "primaryBtn": "Sì, ripara Outlook",
                "secondaryBtn": "Non riparare Outlook",
                "successMsg": "Profilo Outlook ricreato",
                "successMsgOnList": "Profilo Outlook ricreato",
                "failureMsg": "Il profilo Outlook non può essere ricreato",
                "progressMsg": "Ricreazione del profilo Outlook",
                "disclaimer": "L'esecuzione di questa azione ricreerà il tuo profilo Outlook localmente, questo avvierà il download delle email da office Exchange, assicurati che sia disponibile sufficiente larghezza di banda di rete e spazio di archiviazione.",
                "acknowledgeQuery": "Questo potrebbe essere dovuto a problemi di connessione o a impostazioni obsolete. Posso aiutarti a eseguire la risoluzione dei problemi e a riportare Outlook in sincronizzazione."
            },
            "repairOfficeApps": {
                "primaryBtn": "Sì, ripara le app di Office",
                "secondaryBtn": "Non riparare le app di Office",
                "successMsg": "App di Office riparate",
                "successMsgOnList": "App di Office riparate",
                "failureMsg": "Le applicazioni di Office non possono essere riparate",
                "progressMsg": "Le app di Office sono in fase di reinstallazione",
                "disclaimer": "L'esecuzione di questa azione reinstallerà contemporaneamente le app di Office e tenterà di ripararle, si prega di salvare tutto il lavoro non salvato prima di procedere.",
                "acknowledgeQuery": "Questo potrebbe essere dovuto a un'installazione danneggiata o a un problema di compatibilità. Posso aiutarti a riparare le app di Office in modo che si aprano senza problemi."
            },
            "intuneSync": {
                "primaryBtn": "Sì, avvia sincronizzazione intune",
                "secondaryBtn": "Non avviare la sincronizzazione",
                "successMsg": "La sincronizzazione Intune è stata completata",
                "successMsgOnList": "La sincronizzazione Intune è stata completata",
                "failureMsg": "La sincronizzazione Intune non può essere avviata",
                "progressMsg": "Sincronizzazione Intune in corso",
                "disclaimer": "Si prega di notare che questa azione sta solo riavviando i servizi di sincronizzazione Intune, non reinstalla o ripara Intune (Portale aziendale).",
                "acknowledgeQuery": "Posso aiutarti ad aggiornare lo stato del tuo dispositivo e sincronizzarlo con Intune per garantire che sia conforme, aggiornato e applichi i criteri più recenti."
            },
            "teamsAddin": {
                "primaryBtn": "Sì, abilita il componente aggiuntivo MS Teams",
                "secondaryBtn": "Non abilitare il componente aggiuntivo",
                "successMsg": "Riparazione del componente aggiuntivo MS Teams completata",
                "successMsgOnList": "Riparazione del componente aggiuntivo MS Teams completata",
                "failureMsg": "Il componente aggiuntivo MS Teams non può essere abilitato",
                "progressMsg": "Il componente aggiuntivo MS Teams è in fase di abilitazione",
                "disclaimer": "Si prega di notare che la riparazione del componente aggiuntivo MS Teams richiede il riavvio di Outlook. Si prega di salvare tutto il lavoro prima di procedere.",
                "acknowledgeQuery": "Posso aiutarti a ripristinare il componente aggiuntivo di Teams in Outlook così potrai pianificare nuovamente le riunioni. Fai clic sul pulsante qui sotto per continuare."
            },
            "windowsUpdate": {
                "primaryBtn": "Sì, controlla gli aggiornamenti",
                "secondaryBtn": "No, non controllare",
                "successMsg": "L'aggiornamento di Windows è stato attivato",
                "successMsgOnList": "L'aggiornamento di Windows è stato attivato",
                "failureMsg": "Impossibile attivare l'aggiornamento di Windows",
                "progressMsg": "Controllo degli aggiornamenti in corso",
                "disclaimer": "Questa azione è progettata per controllare e scaricare aggiornamenti da Microsoft, assicurati di essere connesso a una rete adeguata per scaricare eventuali aggiornamenti.",
                "acknowledgeQuery": "Posso aiutarti a risolvere i problemi di aggiornamento e conformità di Windows sul tuo dispositivo. Fai clic sul pulsante qui sotto per continuare"
            },
            "smartSolution": {
                "systemName": "Nome del sistema",
                "primaryBtn": "Richiedi controllo sanitario",
                "secondaryBtn": "Non ora",
                "askToRunHealthCheck": "Vuoi che l'assistenza esegua un rapido controllo della salute?",
                "healthCheckApiRunning": "Analisi ed esecuzione del controllo della salute su",
                "healthCheckApiFail": "Impossibile recuperare le informazioni sul controllo della salute, per favore riprova",
                "healthCheckApiSuccess": "Ho analizzato il sistema. Persistono i seguenti problemi:",
                "systemCheckMsg": "Controllo del sistema in corso",
                "systemCheckMessages": {
                    "recentlyStarted": "Il sistema è aggiornato e recentemente avviato",
                    "appsHealthy": "Tutte le installazioni delle app sono sane",
                    "driveSpace": "Ampio spazio libero sul disco di sistema disponibile",
                    "noCrashes": "Nessun crash dell'applicazione rilevato di recente"
                },
                "healthCheckNoIssue": "Ho analizzato il sistema. <b>Tutto sembra funzionare correttamente.</b>",
                "recommendedActionHeading": "Azioni Raccomandate",
                "askForElaboration": "Puoi anche elaborare il problema specifico o caricare lo screenshot del problema che stai affrontando.",
                "remindForSystemCheck": "Va bene, puoi farmi sapere quando vuoi eseguire un controllo del sistema.",
                "recommendedFixesHeading": "Correzioni Raccomandate",
                "recommendedActionInfo": "Seleziona o deseleziona le correzioni proposte, se necessario",
                "noRecommendedAction": "Nessuna azione raccomandata disponibile",
                "initiateActionsButton": "Inizia a risolvere",
                "selectedActionsProgress": "Le azioni selezionate sono in fase di elaborazione.",
                "selectedActionsProgressNote": "Sentiti libero di usare l'assistenza mentre l'azione viene eseguita. Il tuo elemento di azione è stato aggiunto alla lista dei compiti di assistenza e puoi controllare il progresso. Sarai notificato una volta che l'azione sarà completata.",
                "selectedActionsCompleted": "Le azioni selezionate sono state completate con successo.",
                "selectedActionsFailed": "Le azioni selezionate non sono riuscite. Controlla la scheda dei compiti di assistenza per i dettagli.",
                "selectedActionsPartiallyCompleted": "Le azioni selezionate sono parzialmente completate. Controlla la scheda dei compiti di assistenza per i dettagli.",
                "myActionDone": "Segna come completato",
                "manualActionDisclaimer": "Questo processo include sia passaggi automatizzati che manuali. Si prega di completare le azioni quando richiesto",
                "manualActionNotification": "Per finalizzare la correzione, si prega di eseguire passaggi aggiuntivi manualmente menzionati sotto 'Le mie Azioni'.",
                "deviceSelectionHeading": "Vedo che stai usando più sistemi. Se desideri eseguire l'azione seguente su un sistema diverso, scegli dalla lista qui sotto.",
                "deviceSelectionLabel": "Scegli il sistema per l'azione Nexthink",
                "alerts": {
                    "successTitle": "Compito completato!",
                    "successMessage": "Le azioni selezionate sono state completate con successo.",
                    "errorTitle": "Compito fallito!",
                    "errorMessage": "Si è verificato un errore nell'elaborazione della tua azione selezionata.",
                    "partialTitle": "Compito completato parzialmente",
                    "partialMessage": "Le azioni selezionate sono parzialmente completate. Controlla la scheda dei compiti di assistenza per i dettagli."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "Ci sono state <n> occorrenze di schermate blu sul tuo dispositivo negli ultimi 7 giorni.",
                        "action": "Per favore contatta GSD per ulteriore aiuto",
                        "actionInfo": "(Nessuna azione) per favore contatta GSD per ulteriore assistenza"
                    },
                    "edgeCrashes": {
                        "message": "Abbiamo trovato prove di <n> crash del browser Edge negli ultimi 7 giorni. Cercheremo di risolvere questo problema eseguendo uno script sul tuo computer.",
                        "action": "Pulisci la cache del browser Edge",
                        "actionInfo": "Questo pulisce le cache del browser Edge e non modifica i file personali"
                    },
                    "chromeCrashes": {
                        "message": "Abbiamo trovato prove di <n> crash del browser Chrome negli ultimi 7 giorni. Cercheremo di risolvere questo problema eseguendo uno script sul tuo computer.",
                        "action": "Pulisci la cache del browser Chrome",
                        "actionInfo": "Questo pulirà la tua cache di Chrome, nessun file esistente viene modificato."
                    },
                    "ZScalarStatus": {
                        "message": "Abbiamo trovato che il servizio Zscaler ha avuto alcuni problemi sul tuo dispositivo. Possiamo cercare di risolvere questo problema eseguendo uno script sul tuo computer.",
                        "action": "Riavvia il servizio Zscaler",
                        "actionInfo": "Questa azione riavvierà la connessione di rete. Non ha alcun impatto sui programmi aperti."
                    },
                    "ZScalarState": {
                        "message": "Abbiamo trovato che il servizio Zscaler ha avuto alcuni problemi sul tuo dispositivo. Possiamo cercare di risolvere questo problema eseguendo uno script sul tuo computer.",
                        "action": "Ripristina Zscaler",
                        "actionInfo": "Questa azione riavvierà la connessione di rete. Non ha alcun impatto sui programmi aperti."
                    },
                    "driveFreeSpace": {
                        "message": "Il tuo dispositivo ha solo <n> GB di spazio libero rimanente. Per garantire un computer che funzioni in modo ottimale, consigliamo di aumentare la quantità di spazio libero disponibile per Windows, eseguendo uno script sul tuo computer.",
                        "action": "Esegui pulizia disco",
                        "actionInfo": "Solo i file temporanei e il cestino del tuo dispositivo vengono puliti nell'azione"
                    },
                    "daysSinceFullBoot": {
                        "message": "Il tuo dispositivo non è stato completamente riavviato negli ultimi <n> giorni. Questo è diverso dalla normale procedura di spegnimento. Consigliamo di riavviare completamente il tuo computer (Start | Spegnimento | Riavvio)",
                        "action": "Riavvia il dispositivo il prima possibile.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "Abbiamo trovato prove di <n> crash relativi a Microsoft Teams, negli ultimi 7 giorni. Possiamo cercare di risolvere questo problema eseguendo uno script per pulire la cache di Microsoft Teams.",
                        "action": "Esegui pulizia della cache di Teams",
                        "actionInfo": "Questa azione pulisce la cache di MS Teams e la riavvia. Questo può anche eliminare messaggi di Teams non inviati / bozza."
                    },
                    "teamsPluginDisabled": {
                        "message": "Abbiamo rilevato che il tuo componente aggiuntivo Microsoft Teams all'interno di Microsoft Outlook. Questo causa problemi tra le due applicazioni. Possiamo cercare di risolvere questo problema eseguendo uno script per riconfigurare queste impostazioni.",
                        "action": "Imposta plugin Outlook",
                        "actionInfo": "Questa azione abilita il plug-in Teams nel tuo Outlook e riavvia l'app."
                    },
                    "outlookOstStatus": {
                        "message": "Il tuo profilo Outlook ha superato la sua dimensione ottimale, che è noto per causare problemi con la tua casella di posta. Possiamo cercare di risolvere questo problema con uno script per ricreare questo file.",
                        "action": "Ripara file OST di Outlook",
                        "actionInfo": "Questo rinomina il tuo file OST di Outlook e riavvia l'app. Eliminerà qualsiasi email in bozza."
                    },
                    "lastOsUpdate": {
                        "message": "Possiamo vedere che il tuo servizio di aggiornamento di Windows non funziona come previsto e il tuo computer è stato aggiornato l'ultima volta <n> giorni fa. Consigliamo di riavviare completamente il tuo computer (Start | Spegnimento | Riavvio) che aiuta a ripristinare alcune impostazioni.",
                        "action": "Riavvia il dispositivo il prima possibile",
                        "actionInfo": ""
                    }
                },
                "acknowledgeQuery": "Posso aiutarti a risolvere il problema con il tuo dispositivo. Verifichiamo e risolviamo il problema"
            },
            "declineScriptMsg": "Non voglio eseguire lo script Nexthink, assistimi con un'altra soluzione",
            "timezone": {
                "primaryBtn": "Sì, procedi ulteriormente",
                "secondaryBtn": "No, non aggiornare",
                "successMsg": "Il rilevamento del fuso orario è stato impostato su automatico",
                "successMsgOnList": "Il rilevamento del fuso orario è stato impostato su automatico",
                "failureMsg": "La configurazione del fuso orario non può essere aggiornata",
                "progressMsg": "Aggiornamento delle impostazioni del fuso orario",
                "disclaimer": "Si prega di notare che questa azione è progettata per impostare il servizio di fuso orario su automatico, consentendo a Windows di aggiornare l'orologio del desktop in base alla posizione rilevata.",
                "acknowledgeQuery": "Posso aiutarti a correggere l'ora di sistema e le impostazioni del fuso orario. La maggior parte dei problemi legati all'ora, come la deriva dell'orologio, timestamp errati, codici di autenticazione non riusciti o orari di riunione non corretti, sono causati da un fuso orario errato o dalle impostazioni di sincronizzazione automatica disattivate. Fai clic sul pulsante qui sotto per rilevare e correggere automaticamente la configurazione dell'ora e del fuso orario di Windows."
            },
            "chooseBrowser": "Scegli il browser per l'azione di pulizia della cache",
            "outlookAutoComplete": {
                "primaryBtn": "Sì, cancella la cache di Outlook",
                "secondaryBtn": "No, non cancellare la cache di Outlook",
                "successMsg": "Cache di completamento automatico di Outlook cancellata",
                "successMsgOnList": "Cache di completamento automatico di Outlook cancellata",
                "failureMsg": "Non è stato possibile cancellare la cache di completamento automatico di Outlook",
                "progressMsg": "Cancellazione della cache di completamento automatico di Outlook in corso",
                "disclaimer": "Si prega di notare che la cancellazione della cache di completamento automatico di Outlook rimuoverà i suggerimenti degli indirizzi e-mail salvati. Questa azione non può essere annullata.",
                "acknowledgeQuery": "Posso aiutarti a correggere la cache del completamento automatico di Outlook. Fai clic sul pulsante qui sotto per correggere automaticamente il completamento automatico di Outlook."
            },
            "restartZscalar": {
                "primaryBtn": "Sì, procedi",
                "secondaryBtn": "No, non riavviare Zscaler",
                "successMsg": "Zscaler riavviato",
                "successMsgOnList": "Zscaler riavviato",
                "failureMsg": "Zscaler non può essere riavviato",
                "progressMsg": "Riavvio dei servizi Zscaler in corso",
                "disclaimer": "Si prega di notare che il riavvio di Zscaler può disconnettere brevemente la connessione internet e le applicazioni di lavoro. Di solito richiede meno di un minuto.",
                "acknowledgeQuery": "Posso aiutarti a risolvere i problemi dei servizi Zscaler. Fai clic sul pulsante qui sotto per risolvere i problemi di Zscaler."
            },
            "onedrive": {
                "primaryBtn": "Sì, ripara OneDrive",
                "secondaryBtn": "No, non eseguire la riparazione di OneDrive",
                "successMsg": "La riparazione di OneDrive è stata completata",
                "successMsgOnList": "La riparazione di OneDrive è stata completata",
                "failureMsg": "Non è stato possibile completare correttamente l'azione di riparazione di OneDrive",
                "progressMsg": "Esecuzione della riparazione di OneDrive",
                "disclaimer": "Si noti che la riparazione di OneDrive comporterà la sincronizzazione dei file locali con il cloud e potrebbe potenzialmente interrompere le sincronizzazioni personalizzate per Onedrive",
                "acknowledgeQuery": "Posso aiutarti a risolvere i problemi di OneDrive. Fai clic sul pulsante qui sotto per risolvere i problemi di OneDrive."
            },
            "smartcard": {
                "primaryBtn": "Sì, rimuovi la Smart card",
                "secondaryBtn": "No, non rimuovere la Smartcard",
                "successMsg": "La Microsoft Smartcard è stata rimossa",
                "successMsgOnList": "La Microsoft Smartcard è stata rimossa",
                "failureMsg": "Impossibile rimuovere la Microsoft Smartcard",
                "progressMsg": "Rimozione della Microsoft Smartcard",
                "disclaimer": "L'esecuzione di questa azione può richiedere fino a 1 minuto.",
                "acknowledgeQuery": "Posso aiutarti a risolvere i problemi del lettore Microsoft Smart Card. Fai clic sul pulsante qui sotto per risolvere i problemi della Smart Card."
            },
            "errorFetchingReport": "Mi dispiace, non sono riuscito a recuperare il report. Per favore riprova più tardi.",
            "automatedFix": "Correzione automatica",
            "automatedFixConsent": "Posso risolvere questo problema sul tuo dispositivo. Desideri che avvii la correzione automatica?",
            "primaryButton": "Sì, avvia la correzione",
            "teamViewerReset": {
                "primaryBtn": "Sì, procedi",
                "secondaryBtn": "No, non reimpostare",
                "successMsg": "I servizi di Teamviewer sono stati reimpostati",
                "successMsgOnList": "I servizi di Teamviewer sono stati reimpostati",
                "failureMsg": "Impossibile reimpostare i servizi di Teamviewer",
                "progressMsg": "I servizi di Teamviewer sono in fase di riavvio",
                "disclaimer": "Questa azione reimposterà i servizi teamviewer e riavvierà l'app teamviewer; assicurati di aver salvato il lavoro prima di procedere",
                "acknowledgeQuery": "Posso aiutarti a reimpostare TeamViewer. Fai clic sul pulsante qui sotto per continuare."
            },
            "zoomUninstall": {
                "primaryBtn": "Sì, disinstalla Zoom",
                "secondaryBtn": "No, non disinstallare",
                "successMsg": "Zoom disinstallato",
                "successMsgOnList": "Zoom disinstallato",
                "failureMsg": "Impossibile rimuovere Zoom",
                "progressMsg": "Disinstallazione di Zoom in corso",
                "disclaimer": "Questa azione disinstallerà Zoom dal tuo dispositivo; verranno anche eliminate tutte le configurazioni di Zoom.",
                "acknowledgeQuery": "Posso aiutarti a disinstallare Zoom. Fai clic sul pulsante qui sotto per continuare."
            },
            "webexUninstall": {
                "primaryBtn": "Sì, disinstalla Webex",
                "secondaryBtn": "No, non disinstallare",
                "successMsg": "Webex disinstallato",
                "successMsgOnList": "Webex disinstallato",
                "failureMsg": "Impossibile rimuovere Webex",
                "progressMsg": "Disinstallazione di Webex in corso",
                "disclaimer": "Questa azione disinstallerà Cisco Webex dal tuo dispositivo; verranno anche eliminate tutte le configurazioni di Cisco Webex.",
                "acknowledgeQuery": "Posso aiutarti a disinstallare Cisco Webex. Fai clic sul pulsante qui sotto per continuare."
            },
            "recommendedAction": "Azione consigliata",
            "noKbArticleFound": "Non sono stati trovati passaggi manuali o articoli della knowledge base per questo problema. Tuttavia, è presente un'azione consigliata che potrebbe risolverlo:"
        },
        "sessions": {
            "title": "Chat Recenti",
            "clearAll": "Elimina tutte le chat",
            "deleteMessage": "Elimina sessione",
            "footer": "Nota: Le conversazioni degli ultimi 30 giorni saranno memorizzate.",
            "noRecentChat": "Nessuna chat recente",
            "startNewChat": "Inizia nuova chat",
            "learnMore": "Scopri di più.",
            "learnMoreTooltip": "Secondo la politica di conservazione di MyHelp, le tue chat recenti saranno disponibili per 30 giorni a meno che tu non elimini le chat recenti utilizzando i pulsanti di eliminazione o cancellazione."
        },
        "search": "E.ON Search",
        "feedbackMsg": "Grazie per il tuo Feedback! Apprezziamo il tuo aiuto nel migliorare i nostri servizi.",
        "contactNumberPlaceholder": "Numero di contatto con il prefisso internazionale",
        "incidentDetailsLabel": "Riepilogo dell'incidente",
        "contactNumberLabel": "Per favore inserisci il tuo numero di contatto preferito",
        "incError": "Si prega di inserire dettagli validi sull'incidente",
        "contactError": "Si prega di inserire un numero di contatto valido",
        "searchAsk": "Descrivi il tuo problema, ad es. reimpostazione password...",
        "teamsInsights": {
            "specifyDateTime": "Potresti specificare la data e l'ora in cui si è verificato l'evento, nonché la riunione o la chat specifica coinvolta?",
            "date": "Data",
            "getMeetings": "Ottieni riunioni",
            "cancel": "Annulla",
            "noMeetings": "Nessuna riunione trovata per la data selezionata.",
            "meetingInstruction": "Seleziona la riunione specifica che è stata interessata dai problemi di qualità.",
            "identifyIssue": "Identifica il problema",
            "issueDetectionCompleted": "Rilevamento del problema completato.",
            "detectingIssues": "Rilevamento dei problemi della riunione in corso",
            "recommendedActions": "Azioni consigliate:",
            "noInsightsFound": "Nessuna analisi trovata per la chiamata selezionata.",
            "meetingList": "Elenco riunioni",
            "fetchingMeetings": "Recupero di tutte le riunioni Teams della giornata",
            "windowsOnly": "Le analisi delle riunioni sono disponibili solo per le chiamate effettuate da dispositivi Windows.",
            "confirmCreateIncident": "Vuoi creare un ticket di incidente per il problema rilevato nella riunione?",
            "getMeetingsCancelMsg": "Richiesta di recupero riunioni annullata.",
            "identifyIssueCancelMsg": "Richiesta di identificazione del problema annullata.",
            "createIncidentCancelMsg": "Richiesta di creazione dell'incidente annullata.",
            "report": {
                "lowWifiRootCause": "Il segnale Wi-Fi durante la chiamata era debole e potrebbe aver causato problemi di qualità. Se eri connesso da una rete domestica/remota, verifica la distanza dal router.",
                "networkIssueRootCauseManaged": "Sembra che tu fossi connesso da un ufficio E.ON e che tu abbia riscontrato problemi di rete che hanno influito sulla qualità della riunione. Ti consigliamo di aprire un ticket di incidente per segnalarlo e indicare nel ticket la sede in cui ti trovavi.",
                "networkIssueRootCauseUnmanaged": "Sembra che tu non fossi connesso da un ufficio E.ON e che tu abbia riscontrato problemi di rete che potrebbero aver influito sulla qualità della riunione. Verifica la stabilità della tua connessione Wi-Fi o Internet locale. Se possibile, utilizza una connessione cablata o avvicinati al tuo router Wi-Fi per migliorare le prestazioni della rete.",
                "noDataRootCause": "Nessuna analisi era disponibile per questo parametro durante la chiamata.",
                "noIssueRootCause": "Nessun problema rilevato per questo parametro.",
                "noIssueRecommendation": "Nessuna azione richiesta.",
                "failed": "Non riuscito",
                "checking": "Verifica in corso",
                "okay": "OK",
                "na": "N/D",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "Utilizzo CPU del dispositivo",
                    "rootCause": "Abbiamo rilevato un carico CPU elevato sul tuo dispositivo durante la chiamata. Verifica se avevi processi in background o app aperte e in esecuzione durante la chiamata ed evita di tenere troppe app aperte, in modo che le prestazioni hardware del dispositivo possano essere dedicate alla riunione.",
                    "recommendation": "Chiudi le applicazioni in background non necessarie durante le chiamate per ridurre il carico CPU."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Utilizzo memoria del dispositivo",
                    "rootCause": "Abbiamo rilevato un utilizzo elevato della memoria sul tuo dispositivo durante la chiamata. Verifica se avevi processi in background o app aperte e in esecuzione durante la chiamata ed evita di tenere troppe app aperte, in modo che le prestazioni hardware del dispositivo possano essere dedicate alla riunione.",
                    "recommendation": "Chiudi le applicazioni in background non necessarie durante le chiamate per ridurre l'utilizzo della memoria."
                },
                "wifiSignalQuality": {
                    "displayName": "Qualità del segnale Wi-Fi",
                    "recommendation": "Avvicinati al router o passa a una fonte di segnale Wi-Fi più forte."
                },
                "audioJitter": {
                    "displayName": "Jitter audio"
                },
                "audioJBDelay": {
                    "displayName": "Ritardo JB audio"
                },
                "audioRecvLossRate": {
                    "displayName": "Tasso di perdita in ricezione audio"
                },
                "audioRtt": {
                    "displayName": "Tempo di andata e ritorno audio"
                },
                "videoRtt": {
                    "displayName": "Tempo di andata e ritorno video"
                },
                "videoRecvLossRate": {
                    "displayName": "Tasso di perdita in ricezione video"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "Frequenza centrale del canale Wi-Fi (kHz)",
                    "rootCause": "Stai utilizzando una connessione Wi-Fi a 2,4 GHz, che causa frequentemente problemi di qualità della chiamata. Ti consigliamo di passare a una banda Wi-Fi a 5 GHz o superiore.",
                    "recommendation": "Passa a una banda Wi-Fi da 5 GHz (o superiore) per migliorare la qualità della chiamata."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Cambio rete rilevato",
                    "rootCauseManaged": "Abbiamo rilevato cambi di Wi-Fi o del punto di accesso durante la tua chiamata in un ufficio E.ON. Questo potrebbe aver causato un'interruzione della chiamata. Se non ti sei spostato con il tuo dispositivo, ti preghiamo di registrarlo come ticket di incidente.",
                    "rootCauseUnmanaged": "Abbiamo rilevato che non eri connesso da una sede E.ON. Verifica che la tua connessione Wi-Fi sia stabile, poiché i problemi di rete potrebbero influire sulla qualità della riunione."
                }
            }
        }
    },
    "snow": {
        "welcomeNote": "Si prega di trovare di seguito una panoramica sui tuoi ticket di incidenti aperti, le tue richieste e i tuoi asset IT.",
        "tabName": {
            "incidents": "Incidenti",
            "orders": "Ordini",
            "itResources": "Risorse IT",
            "incidentsTable": {
                "noData": "Nessun dato disponibile",
                "btnText": "Apri nuovo incidente",
                "ongoing": "In corso",
                "closed": "Chiuso",
                "headlineText": "Incidenti"
            },
            "orderTable": {
                "number": "Numero",
                "catItem": "Elemento Cat",
                "approvalSet": "Set di approvazione",
                "state": "Stato",
                "dueDate": "Data di scadenza",
                "createdOn": "Creato il",
                "noData": "Nessun dato disponibile",
                "btnText": "Ordina servizi IT",
                "headlineText": "Ordini",
                "tooltipText": "Richiedi e gestisci attrezzature IT, software, licenze o servizi"
            },
            "itResourcesTable": {
                "modelCategory": "Categoria modello",
                "model": "Modello",
                "computerName": "Nome del computer",
                "serialNumber": "Numero di serie",
                "serviceValue1": "Valore del servizio1",
                "serviceValue2": "Valore del servizio2",
                "noData": "Nessun dato disponibile",
                "btnText": "Apri un ticket per risorse IT",
                "headlineText": "I miei asset"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Scheda",
        "favourite": "Preferito",
        "categorizeTiles": "Dashboard personalizzato",
        "enterTabName": "Inserisci nome scheda",
        "tabNameError": "Si prega di inserire un nome scheda unico, con una lunghezza minima di 2 e massima di 20!",
        "tabInputLabel": "Nome scheda",
        "addTabButton": "Aggiungi scheda",
        "personalizeTab": "Personalizza schede",
        "personalizeTiles": "Personalizza tessere",
        "addTab": "Aggiungi nuova scheda",
        "removeTabConfrim": "Sei sicuro di voler rimuovere la scheda",
        "with": " con",
        "cardIn": "tessere in?",
        "actionUndone": "Questa azione non può essere annullata.",
        "categorizeTilesTitle": "Rinomina schede, rimuovi schede e sposta tessere all'interno delle schede",
        "addTabTitle": "Aggiungi nuova scheda. Puoi creare un massimo di 4 schede.",
        "organiseTilesTitle": "Per spostare la posizione delle tessere"
    },
    "dataTable": {
        "pagingData": "Elementi per pagina",
        "itemString": "elementi",
        "ofString": "di"
    },
    "tourData": {
        "userActions": {
            "back": "Indietro",
            "close": "Chiudi",
            "last": "Termina",
            "next": "Avanti",
            "step": "Passo",
            "of": "di",
            "open": "Apri il dialogo",
            "skip": "Salta",
            "start_tour": "Inizia tour",
            "tour_info": "Vuoi che ti mostriamo le funzionalità di base con un rapido tour guidato? Dovrebbe richiedere solo 1-2 minuti..."
        },
        "tile": {
            "step1": "Usa MyHelp per trovare le tue applicazioni di lavoro tipiche o fai qualsiasi domanda sulle risorse E.ON, ad esempio IT, i tuoi progetti, corsi di formazione, politiche aziendali e molto altro.",
            "step2": "Puoi scoprire di più su MyHelp e le sue funzioni, trovare risposte alle domande frequenti e imparare consigli e trucchi utili nella documentazione utente.",
            "step3": "Puoi ancora cambiare la lingua preferita in qualsiasi momento da qui.",
            "step4": "Puoi disconnetterti cliccando qui.",
            "step5": "Inizia una nuova conversazione, recupera le tue chat recenti per continuare da dove hai interrotto o avvia una ricerca E.ON premendo la lente di ingrandimento",
            "step6": "Il tuo dashboard personalizzato ti consente di organizzare e accedere alle tue applicazioni di lavoro preferite. Cerca un'app e aggiungila con il simbolo più. Crea nuove schede e riorganizza le app secondo necessità."
        },
        "tab": {
            "step1": "Puoi aggiungere una nuova scheda cliccando qui.",
            "step2": "Clicca qui per organizzare la sequenza delle tessere.",
            "step3": "Qui puoi rinominare e organizzare le schede."
        },
        "chat": {
            "step1": "Descrivi il tuo problema IT",
            "step1_description": "Ricevi assistenza passo dopo passo per i problemi IT più comuni – basata sulle basi di conoscenza del supporto IT di E.ON. Se necessario, MyHelp ti indirizza anche al canale di supporto IT più adatto.",
            "step2": "Scopri le richieste IT più comuni",
            "step2_description": "Questi esempi mostrano richieste IT frequenti in cui MyHelp può supportarti passo dopo passo.",
            "step3": "Accedi più velocemente alle tue app",
            "step3_description": "Usa il dashboard per salvare le applicazioni utilizzate più spesso e creare il tuo spazio di lavoro personale.",
            "step4": "Avvia una nuova chat o riprendi conversazioni precedenti",
            "step4_description": "Usa la barra laterale per avviare una nuova conversazione o tornare rapidamente alle chat precedenti."
        }
    },
    "allApps": {
        "addAppsBtn": "Aggiungi app",
        "addAppsInfo": "Fai clic su Aggiungi app per iniziare",
        "addAppsTitle": "Crea il tuo spazio di lavoro personalizzato",
        "addAppsDesc": "Aggiungi le applicazioni che utilizzi più spesso per accedere più rapidamente agli strumenti che usi ogni giorno",
        "customTileButton": "Aggiungi carta personalizzata",
        "CustomTileHeading": "Carta personalizzata",
        "customTileTitleLabel": "Titolo della carta",
        "customTileSubTitle": "Descrizione della carta",
        "customTileUrlLabel": "Link della carta",
        "createCardBtn": "Crea carta",
        "modalHeading": "App su E.ON",
        "modalDesc": "Cerca o seleziona un'app da aggiungere alla pagina principale",
        "titleRequired": "Il titolo della carta è richiesto",
        "linkRequired": "Il link della carta è richiesto",
        "searchPlaceholder": "Cerca app"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Portale di onboarding",
        "heading": "Portale di onboarding",
        "subHeading": "Rivedi la tua app, inserisci nuove e condividi l'accesso di gestione con il tuo team.",
        "modules": {
            "home": "Home",
            "apps": "Apps",
            "appsLabel": "Apps",
            "qna": "Q&A",
            "qnaLabel": "Domanda e risposta",
            "review": "Revisione",
            "reviewLabel": "Revisione",
            "onboardApp": "Inserisci nuova app",
            "manageApp": "Gestisci app",
            "defaultApps": "App predefinite",
            "onboardQnA": "Inserisci QnA",
            "manageQnA": "Gestisci QnA",
            "reviewDashboard": "Dashboard revisore",
            "reviewApps": "Rivedi le app",
            "reviewQnA": "Rivedi i Q&A"
        },
        "appOnboardingForm": {
            "formHeading": "Inserisci nuova app",
            "successAlert": "App inserita con successo!",
            "appTitleLabel": "Titolo app",
            "appTitleTooltip": "Nome dell'app da visualizzare",
            "appTitlePlaceholder": "Nome dell'app da visualizzare",
            "appTitleError": "Il titolo dell'app è obbligatorio",
            "appSubTitleLabel": "Sottotitolo app",
            "appSubTitleTooltip": "Sottotitolo dell'app",
            "appSubTitlePlaceholder": "Sottotitolo dell'app",
            "appSubTitleError": "Il sottotitolo dell'app è obbligatorio",
            "appUrlLabel": "URL app",
            "appUrlTooltip": "URL di destinazione dell'app",
            "appUrlPlaceholder": "URL di destinazione dell'app",
            "appUrlError": "L'URL dell'app è obbligatorio",
            "appKeywordsLabel": "synKeywords (separati da virgola)",
            "appKeywordsTooltip": "Inserisci i sinonimi che gli utenti potrebbero usare per trovare l'app e separali con una virgola",
            "appKeywordsPlaceholder": "Inserisci i sinonimi che gli utenti potrebbero usare per trovare l'app e separali con una virgola",
            "appKeywordsError": "Le parole chiave sono obbligatorie",
            "appCompaniesAllowedLabel": "Aziende consentite",
            "appCompaniesAllowedTooltip": "Elenco di tutte le aziende in cui questa app è consentita. Se consentita per tutte, lasciare vuoto.",
            "appCompaniesAllowedInfoMessage": "Elenco di tutte le aziende in cui questa app è consentita. Se consentita per tutte, lasciare vuoto.",
            "appCompaniesAllowedOtherLabel": "Altre aziende consentite",
            "appCompaniesAllowedOtherPlaceholder": "Specifica altre aziende consentite",
            "appCompaniesRestrictedLabel": "Aziende con restrizioni",
            "appCompaniesRestrictedTooltip": "Elenco di tutte le aziende in cui questa app NON è consentita. Se non ci sono restrizioni, lasciare vuoto.",
            "appCompaniesRestrictedInfoMessage": "Elenco di tutte le aziende in cui questa app NON è consentita. Se non ci sono restrizioni, lasciare vuoto.",
            "appCompaniesRestrictedOtherLabel": "Altre aziende con restrizioni",
            "appCompaniesRestrictedOtherPlaceholder": "Specifica altre aziende con restrizioni",
            "appTooltipLabel": "Tooltip (indicare tutte le lingue, se occorre visualizzare nomi diversi)",
            "appTooltipTooltip": "Indicare tutte le lingue, se occorre visualizzare nomi diversi, es. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Indicare tutte le lingue, se occorre visualizzare nomi diversi, es. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Il tooltip è obbligatorio",
            "appIconLabel": "Carica icona app",
            "appIconTooltip": "Carica icona app",
            "previewAppBtn": "Anteprima app",
            "cancelBtn": "Annulla",
            "closeBtn": "Chiudi",
            "submitAppBtn": "Invia app",
            "updateAppBtn": "Aggiorna app",
            "editAppBtn": "Modifica app",
            "appTitlePreview": "Titolo",
            "appSubTitlePreview": "Sottotitolo",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Parole chiave",
            "appCompaniesAllowedPreview": "Aziende consentite",
            "appCompaniesRestrictedPreview": "Aziende con restrizioni",
            "appTooltipPreview": "Tooltip",
            "message": "Una volta inviata un'app, entra in uno stato In sospeso e passa attraverso un ciclo di vita di revisione definito — progredendo da In sospeso → Approvato (in revisione/test) → In QA (formalmente approvato e in fase di verifica) → In produzione (live e visibile agli utenti finali su MyHelp), oppure può essere Rifiutato se non soddisfa i criteri; in tal caso, il soggetto interessato può modificare e inviare nuovamente."
        },
        "qnaOnboardingForm": {
            "formHeading": "Inserisci nuovo QnA",
            "successAlert": "QnA inserito con successo!",
            "qnaQuestionLabel": "Domanda",
            "qnaQuestionTooltip": "Inserisci la domanda per il QnA",
            "qnaQuestionPlaceholder": "Inserisci la domanda",
            "qnaQuestionError": "La domanda è obbligatoria",
            "qnaAnswerLabel": "Risposta",
            "qnaAnswerTooltip": "Inserisci la risposta per il QnA",
            "qnaAnswerPlaceholder": "Inserisci la risposta alla domanda",
            "qnaAnswerError": "La risposta è obbligatoria",
            "qnaCategoryLabel": "Categoria",
            "qnaCategoryTooltip": "Seleziona la categoria per l'elemento QnA",
            "qnaCategoryPlaceholder": "Seleziona la categoria per l'elemento QnA",
            "qnaCategoryError": "La categoria è obbligatoria",
            "qnaCategoryOtherLabel": "Altra categoria",
            "qnaCategoryOtherPlaceholder": "Inserisci una categoria personalizzata",
            "qnaCompaniesAllowedLabel": "Aziende consentite",
            "qnaCompaniesAllowedTooltip": "Elenco di tutte le aziende in cui questa app è consentita. Se consentita per tutte, lasciare vuoto.",
            "qnaCompaniesAllowedInfoMessage": "Elenco di tutte le aziende in cui questa app è consentita. Se consentita per tutte, lasciare vuoto.",
            "qnaCompaniesAllowedOtherLabel": "Altre aziende consentite",
            "qnaCompaniesAllowedOtherPlaceholder": "Specifica altre aziende consentite",
            "qnaCompaniesRestrictedLabel": "Aziende con restrizioni",
            "qnaCompaniesRestrictedTooltip": "Elenco di tutte le aziende in cui questa app NON è consentita. Se non ci sono restrizioni, lasciare vuoto.",
            "qnaCompaniesRestrictedInfoMessage": "Elenco di tutte le aziende in cui questa app NON è consentita. Se non ci sono restrizioni, lasciare vuoto.",
            "qnaCompaniesRestrictedOtherLabel": "Altre aziende con restrizioni",
            "qnaCompaniesRestrictedOtherPlaceholder": "Specifica altre aziende con restrizioni",
            "previewQnABtn": "Anteprima QnA",
            "cancelBtn": "Annulla",
            "submitQnABtn": "Invia QnA",
            "updateQnABtn": "Aggiorna QnA",
            "editQnABtn": "Modifica QnA",
            "addNewQnABtn": "+ Aggiungi QnA",
            "qnaQuestionPreview": "Domanda",
            "qnaAnswerPreview": "Risposta",
            "qnaCompaniesAllowedPreview": "Aziende consentite",
            "qnaCompaniesRestrictedPreview": "Aziende con restrizioni",
            "message": "Una volta inviata una voce Q&A, entra in uno stato In sospeso e passa attraverso un ciclo di vita di revisione definito — progredendo da In sospeso → Approvato (in revisione/test) → In QA (formalmente approvato e in fase di verifica) → In produzione (live e visibile agli utenti finali su MyHelp), oppure può essere Rifiutato se non soddisfa i criteri; in tal caso, il soggetto interessato può modificare e inviare nuovamente."
        },
        "manageBtn": "Gestisci",
        "refreshBtn": "Aggiorna",
        "exportBtn": "Esporta",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Esporta app come CSV",
        "exportAppsExcelBtn": "Esporta app come Excel",
        "exportQnACsvBtn": "Esporta QnA come CSV",
        "exportQnAExcelBtn": "Esporta QnA come Excel",
        "approveBtn": "Approva",
        "rejectBtn": "Rifiuta",
        "toQABtn": "Sposta in QA",
        "toProdBtn": "Sposta in produzione",
        "editBtn": "Modifica",
        "viewBtn": "Visualizza",
        "closeBtn": "Chiudi",
        "dashboard": {
            "appsTitle": "App accessibili",
            "appsText": "App disponibili tramite proprietà o condivisione del team.",
            "qnaTitle": "Domande e risposte",
            "qnaText": "Domande e risposte disponibili tramite proprietà o condivisione del team."
        },
        "modalLabel": {
            "reviewAppTitle": "Revisiona app per l'integrazione",
            "reviewQnATitle": "Revisiona Q&A per l'integrazione",
            "owner": "Proprietario",
            "createdOn": "Creato il",
            "status": "Stato",
            "url": "URL",
            "tooltip": "Tooltip",
            "companiesAllowed": "Aziende consentite",
            "companiesRestricted": "Aziende limitate",
            "keywords": "Parole chiave",
            "reviewerComments": "Commenti di revisione",
            "category": "Categoria",
            "question": "Domanda",
            "answer": "Risposta",
            "mail": "E-mail"
        },
        "statusLabel": {
            "pending": "In sospeso",
            "approved": "Approvato",
            "rejected": "Rifiutato",
            "onhold": "In attesa",
            "unknown": "Sconosciuto",
            "all": "Tutti",
            "inQA": "In QA",
            "inProd": "In produzione"
        },
        "activityLabel": {
            "allowed": "Consentito",
            "restricted": "Limitato"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Azione",
            "icon": "Icona",
            "title": "Titolo",
            "subTitle": "Sottotitolo",
            "question": "Domanda",
            "answer": "Risposta",
            "category": "Categoria",
            "owner": "Proprietario",
            "description": "Descrizione",
            "apps": "Apps",
            "qna": "Domanda e risposta",
            "defaultApps": "App predefinite",
            "defaultAppsActivity": "Modifiche alle app predefinite",
            "search": "Cerca",
            "selectCompany": "Seleziona azienda",
            "otherCompany": "Nome altra azienda",
            "selectAll": "Seleziona tutto",
            "company": "Azienda",
            "update": "Aggiorna",
            "comments": "Commenti"
        },
        "noData": {
            "dashboardEmpty": "Nessuna app o Q&A è stata aggiunta",
            "dashboardAppsEmpty": "Nessuna app è stata aggiunta",
            "dashboardQnAEmpty": "Nessun Q&A è stato aggiunto",
            "reviewDashboardEmpty": "Nessuna app o Q&A è stata inviata per la revisione.",
            "reviewAppsEmpty": "Nessuna app è stata inviata per la revisione.",
            "reviewQnAEmpty": "Nessun Q&A è stato inviato per la revisione."
        },
        "manageApp": {
            "heading": "Gestisci app",
            "subHeading": "Vengono mostrate solo le app di cui sei proprietario o a cui hai ricevuto accesso."
        },
        "manageQnA": {
            "heading": "Gestisci QnA",
            "subHeading": "Vengono mostrati solo i QnA di cui sei proprietario o a cui hai ricevuto accesso."
        },
        "defaultApps": {
            "heading": "App predefinite",
            "subHeading": "Queste sono le app predefinite disponibili per tutti gli utenti. Puoi richiedere di caricare nuove app o richiedere l'accesso per gestire le app esistenti dalla sezione Gestisci app.",
            "searchPlaceholder": "Cerca app"
        },
        "reviewDashboard": {
            "heading": "Dashboard revisione",
            "subHeading": "Rivedi le richieste in sospeso di onboarding app e approvale o rifiutale. Le tue revisioni tempestive ci aiutano a mantenere una raccolta di app rilevante e utile per tutti."
        },
        "reviewApps": {
            "heading": "Revisione app",
            "subHeading": "Rivedi le richieste in sospeso di onboarding app e approvale o rifiutale. Le tue revisioni tempestive ci aiutano a mantenere una raccolta di app rilevante e utile per tutti."
        },
        "reviewQnA": {
            "heading": "Revisione Q&A",
            "subHeading": "Rivedi le richieste in sospeso di onboarding QnA e approvale o rifiutale. Le tue revisioni tempestive ci aiutano a mantenere una raccolta QnA rilevante e utile per tutti."
        },
        "reviewQueue": {
            "heading": "Coda di revisione",
            "subHeading": "Rivedi e approva o rifiuta le richieste di caricamento dell'app in sospeso. Le tue tempestive revisioni ci aiutano a mantenere una raccolta di app rilevante e utile per tutti."
        },
        "activityLog": {
            "heading": "Registro attività"
        },
        "quickActions": {
            "title": "Azioni rapide",
            "onboardNewApp": "Inserisci nuova app",
            "manageApps": "Gestisci app",
            "defaultApps": "App predefinite",
            "onboardNewQnA": "Inserisci nuova domanda e risposta",
            "manageQnA": "Gestisci domande e risposte",
            "reviewerDashboard": "Dashboard revisore",
            "reviewApps": "Rivedi le app inserite",
            "reviewQnA": "Rivedi i Q&A inseriti"
        }
    },
    "sourceSelector": {
        "title": "Seleziona fonte",
        "allSources": "Tutte le fonti",
        "allSourcesDesc": "Cerca in tutte le fonti di informazione interne di E.ON",
        "eonKnowledgeBase": "Banca dati della conoscenza E.ON",
        "eonKnowledgeBaseDesc": "Accesso alla conoscenza aziendale generale",
        "eonMyItOrder": "E.ON I miei ordini IT",
        "eonMyItOrderDesc": "Gestisci e traccia gli ordini di servizio IT",
        "eonItKnowledgeBase": "Banca dati della conoscenza IT E.ON",
        "eonItKnowledgeBaseDesc": "Trova informazioni e soluzioni relative all'IT",
        "myGenius": "My Genius",
        "myGeniusDesc": "Esplora corsi e materiali di apprendimento interni",
        "confluenceAll": "Confluence (Tutti)",
        "confluenceAllDesc": "Sfoglia la documentazione collaborativa",
        "sharepointAll": "SharePoint (Tutti)",
        "sharepointAllDesc": "Sfoglia file e risorse condivisi",
        "eonApps": "App E.ON",
        "eonAppsDesc": "Scopri e utilizza applicazioni aziendali",
        "hrPolicies": "Politiche HR",
        "hrPoliciesDesc": "Accesso a politiche e guide HR",
        "compass": "Compass",
        "compassDesc": "Esplora l'intranet E.ON",
        "back": "Indietro",
        "search": "Cerca...",
        "noMatches": "Nessun risultato"
    },
    "ailoader": {
        "thinking": "Pensando",
        "reading": "Lettura delle fonti",
        "processing": "Elaborazione",
        "analysing": "Analisi dei risultati",
        "preparing": "Preparando risposta",
        "working": "Sto elaborando la tua risposta. Potrebbe volerci qualche istante."
    },
    "compassScopeSelector": {
        "title": "Seleziona unità aziendale",
        "iconLabel": "Ambito di ricerca",
        "localSearch": "Ricerca locale",
        "compassWideSearch": "Ricerca su tutto Compass",
        "resetToCompassWide": "Reimposta alla ricerca su tutto Compass",
        "switchToLocal": "Passa alla ricerca locale",
        "localDescription": "Cerca all'interno della tua azienda e dei post pubblici",
        "compassWideDescription": "Cerca in tutte le unità aziendali"
    },
    "errorMessages": {
        "azureAiContentViolation": "La risposta è stata filtrata a causa della query che ha attivato la politica di gestione dei contenuti di Azure OpenAI. Si prega di modificare la query e riprovare."
    }
}
